import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { CreateStaffReport, CreateStaffReportTemporary, ImageUpload, LeaveTypeList, SpecificTemporaryReport, SpecificSavedReport } from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { DurationValidation, NonEmptyValidation, NumberValidation, NumberValidationw0, StringValidation, YearValidation } from "../../Store/validate";
import { FinancialMonthOptions, FinancialYearOptions, FinancialYearView, IsOldReportYear, IsOldReportYr, Restrict, calculateSum } from "../Common/FinancialYear";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
import { kMonths } from "../../Store/constants";
import AppraisalReportSpecificView from '../Common/AppraisalReportSpecificView'
const StaffActivityReport = () => {
  const { first_name, desingation, department, dob, father_name, pay_level, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams()
  const inputRef = useRef({});
  const inputRefA = useRef({});
  const inputRefB = useRef({});
  const inputRefC = useRef({});
  const inputRefD = useRef({});
  const inputRefE = useRef({});

  const navigate = useNavigate();
  const { pathname } = useLocation()
  const isSavedReport = pathname.includes('StaffSavedReport')
  function isEmpty(value) {
    return (value == null || (typeof value === "string" && value.trim().length === 0));
  }
  const isSpecific = !isEmpty(id)
  useEffect(() => {
    getLeaveType()
    if (isSpecific) {
      getSpecificTempReportlist();
    }
  }, []);
  const [leaveType, setLeaveType] = useState([])

  const [active, setActive] = useState(0);
  const getLeaveType = async () => {
    const response = await LeaveTypeList(token)
    if (response && response?.statusCode === 200) {
      setLeaveType(response?.data?.map((item) => ({
        value: item?.id,
        label: item?.value
      })))
    }
  }

  const handle = (key, value, value2) => {
    if (value === "no") {
      setReport({ ...report, [key]: [] });
    } else if (value === "yes") {
      setReport({ ...report, [key]: [value2] });
    }
  };

  const [validation, setValidation] = useState({
    academic_qualification: {},
    period_of_absence: {},
    non_sponsored_training: {},
    sponsored_contact_mode: {},
    skill_development: {},
    development_of_moocs: {},
    resource_person: {},
    development_of_training_manual: {},
    courses_handled_for_pg_phd: {},
    new_courses_developed_offered: {},
    curriculum_developed_or_revised: {},
    phd_research_guidances: {},
    post_graduate_thesis_guidances: {},
    sponsored_research_projects: {},
    consultancy_works_carried_out: {},
    research_publications: {},
    papers_presentation: {},
    books_authored: {},
    patents: {},
    awards_details: {},
    administrative_contributions: {},
    infrastructure_development: {},
    revenue_generated_through_training_program: {},
    research_or_academic_events: {},
    events_conducted: {},
    new_initiatives: {},
    resource_person_in_training_programmes: {},
    training_programmes_attended: {},
    participation_and_academic_contributions: {},
    overseas_visited_for_academic_events: {},
    participation_and_contributions: {},
    editor_in_chief: {},
    national_or_international_assignment: {},
    fellow_or_life_member: {},
  });
  const validation2 = Object.fromEntries(Object.entries(validation).filter(([key, value]) => (key !== 'academic_year' && key !== 'month')))

  function Splitparts(obj, start, end) {
    const entries = Object.entries(obj); // Convert object to array of [key, value] pairs
    const firstTwoEntries = entries.slice(start, end); // Select the first two entries
    return Object.fromEntries(firstTwoEntries); // Convert back to object
  }
  const partAValidation = Splitparts(validation2, 0, 2)
  const partBValidation = Splitparts(validation2, 2, 11)
  const partCValidation = Splitparts(validation2, 11, 20)
  const partDValidation = Splitparts(validation2, 20, 26)
  const partEValidation = Splitparts(validation2, -8)

  let dummyarray = []

  const focusError = (validationPart) => {
    if (validation?.academic_year?.status === false) {
      dummyarray.push('academic_year')
    }
    if (validation?.month?.status === false) {
      dummyarray.push('month')
    }
    for (const key1 in validationPart) {
      if (validationPart[key1][0]) {
        let nestedobject1 = validationPart[key1]
        for (const key2 in nestedobject1) {
          let nestedobject2 = nestedobject1[key2]
          for (const key3 in nestedobject2) {
            let finalobject = nestedobject2[key3]
            if (finalobject.status === false) {
              dummyarray.push(key1 + '_' + key3 + '_' + key2)
            } else if (!finalobject.status) {
              for (const key5 in finalobject) {
                let nestedobjectx = finalobject[key5]
                if (nestedobjectx.status === false) {
                  dummyarray.push(key1 + '_' + key3 + '_' + key5 + '_' + key2)
                }
              }
            }
          }
        }
      }
    }
  }
  if (active === 0) {
    focusError(partAValidation)
  } else if (active === 1) {
    focusError(partBValidation)
  } else if (active === 2) {
    focusError(partCValidation)
  } else if (active === 3) {
    focusError(partDValidation)
  } else if (active === 4) {
    focusError(partEValidation)
  }
  // console.log(dummyarray)
  let checkstatus2 = []
  const focusError2 = (validationPart) => {
    if (validation?.academic_year?.status === false) {
      checkstatus2.push('academic_year')
    }
    if (validation?.month?.status === false) {
      checkstatus2.push('month')
    }
    for (const key1 in validationPart) {
      if (validationPart[key1][0]) {
        let nestedobject1 = validationPart[key1]
        for (const key2 in nestedobject1) {
          let nestedobject2 = nestedobject1[key2]
          for (const key3 in nestedobject2) {
            let finalobject = nestedobject2[key3]
            if (finalobject.status === false) {
              checkstatus2.push(key1 + '_' + key3 + '_' + key2)
            } else if (!finalobject.status) {
              for (const key5 in finalobject) {
                let nestedobjectx = finalobject[key5]
                if (nestedobjectx.status === false) {
                  checkstatus2.push(key1 + '_' + key3 + '_' + key5 + '_' + key2)
                }
              }
            }
          }
        }
      }
    }
  }
  const [click, setClick] = useState(false)
  const [statusAcceptModel, setStatusAcceptModel] = useState(false);
  const links = ["Part - A", "Part - B", "Part - C", "Part - D", "Part - E"];
  const showSelected = (index) => {
    setActive(index);
    setClick(false)
  };

  const [report, setReport] = useState({
    month: 0,
    academic_qualification: [
      {
        id: 0,
        qualification: "",
        attachment: "",
      },
    ],
    period_of_absence: [
      {
        id: 0,
        leave_type: "",
        no_of_days: "",
      },
    ],
    non_sponsored_training: [],
    sponsored_contact_mode: [],
    skill_development: [],
    development_of_moocs: [],
    resource_person: [],
    development_of_training_manual: [],
    courses_handled_for_pg_phd: [],
    new_courses_developed_offered: [],
    curriculum_developed_or_revised: [],
    phd_research_guidances: [],
    post_graduate_thesis_guidances: [],
    sponsored_research_projects: [],
    consultancy_works_carried_out: [],
    research_publications: [],
    papers_presentation: [],
    books_authored: [],
    patents: [],
    awards_details: [],
    administrative_contributions: [],
    infrastructure_development: [],
    revenue_generated_through_training_program: [],
    research_or_academic_events: [],
    events_conducted: [],
    new_initiatives: [],
    resource_person_in_training_programmes: [],
    training_programmes_attended: [],
    participation_and_academic_contributions: [],
    overseas_visited_for_academic_events: [],
    participation_and_contributions: [],
    editor_in_chief: [],
    national_or_international_assignment: [],
    fellow_or_life_member: [],
  });
  function appendIds(data) {
    const newData = {};
    for (const key in data) {
      if (Array.isArray(data[key])) {
        newData[key] = data[key].map((obj, index) => {
          return { ...obj, id: index === 0 ? 0 : index + 1 };
        });
      } else if (key === "month") {
        newData[key] = { value: data[key], label: kMonths[data[key] - 1] };
      } else {
        newData[key] = data[key];
      }
    }
    return newData;
  }

  const getSpecificTempReportlist = async () => {
    let response
    response = isSavedReport ? await SpecificSavedReport(id, token) : await SpecificTemporaryReport(id, token);
    if (response && response.statusCode === 200) {
      setReport(appendIds(response.data));
    } else {
      errorMsg(response.message);
    }
  };
  const setNormalData = (e, key) => {
    setReport({ ...report, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const setData = (e, key, field, index) => {
    let data = report[key] ?? [];
    data[index] = { ...data[index], [field]: e };

    setReport({
      ...report,
      [key]: data,
    });
    if (validation[key]) setValidation({
      ...validation, [key]: {
        ...validation[key],
        [index]: {
          ...validation[key][index],
          [field]: false
        }
      }
    });
  };


  const setData1 = (e, key, field, subField, index) => {
    let data = report[key] ?? [];
    data[index] = { ...data[index], [field]: { ...data[index][field], [subField]: e } };
    setReport({
      ...report,
      [key]: data,
    });
    if (validation[key]) setValidation({
      ...validation, [key]: {
        ...validation[key],
        [index]: {
          ...validation[key][index],
          [field]: {
            ...validation[key][index][field],
            [subField]: false
          }
        }
      }
    });
  };
  const setAddArrayData = (key, index) => {
    let data = report[key];

    data.push({ id: index + 1 });
    setReport({
      ...report,
      [key]: data,
    });
  };
  const setRemoveArrayData = (key, id) => {
    let data = [...report[key]];
    data = data.filter((_, index) => _.id !== id);
    setReport({
      ...report,
      [key]: data,
    });
  };
  const UploadDocument = async (e, key, field, index) => {
    const file = e.target.files[0];

    const maxSizeInBytes = 2 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      errorMsg("File size exceeds the limit of 2MB");
      return;
    }

    let formData = new FormData();
    let str = file.name;
    formData.append("file", file);
    formData.append("fileName", moment().format("YYYYMMDDHHmmss") + "_" + str);
    formData.append("file_path", "/reference_document");

    const response = await ImageUpload(formData);
    if (response && response.statusCode === 200) {
      setData(response.data, key, field, index);
      successMsg(response.message);
    } else {
      errorMsg(response.message);
    }
  };
  const removeIdAndEmptyObjects = (obj) => {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }
    if (Array.isArray(obj)) {
      const newArray = obj.map((item) => removeIdAndEmptyObjects(item)).filter((item) => item !== null);
      return newArray.length > 0 ? newArray : [];
    }
    const newObj = {};
    for (const key in obj) {
      if (key !== "id") {
        const value = removeIdAndEmptyObjects(obj[key]);

        if (value !== "" && value !== null) {
          newObj[key] = value;
        }
      }
    }

    return Object.keys(newObj).length > 0 ? newObj : null;
  };
  const checkStatus = (data) => {
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const innerData = data[key];
        for (const innerKey in innerData) {
          if (Object.hasOwnProperty.call(innerData, innerKey)) {
            const nestedObject = innerData[innerKey];
            for (const nestedKey in nestedObject) {
              if (Object.hasOwnProperty.call(nestedObject, nestedKey)) {
                if (nestedObject[nestedKey]?.status === false) {
                  return false;
                }
              }
            }
          }
        }
      }
    }
    return true;
  };

  function checkAllStatusTrue(obj) {
    if (typeof obj !== 'object' || obj === null) return true;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object') {
          if (!checkAllStatusTrue(obj[key])) return false;
        } else if (key === 'status' && obj[key] === false) {
          return false;
        }
      }
    }
    return true;
  }

  // console.log(checkAllStatusTrue(validation))
  const handleSubmit = async (e, key) => {
    e.preventDefault();
    let validate = {
      academic_qualification: {},
      period_of_absence: {},
      non_sponsored_training: {},
      sponsored_contact_mode: {},
      skill_development: {},
      development_of_moocs: {},
      resource_person: {},
      development_of_training_manual: {},
      courses_handled_for_pg_phd: {},
      new_courses_developed_offered: {},
      curriculum_developed_or_revised: {},
      phd_research_guidances: {},
      post_graduate_thesis_guidances: {},
      sponsored_research_projects: {},
      consultancy_works_carried_out: {},
      research_publications: {},
      papers_presentation: {},
      books_authored: {},
      patents: {},
      awards_details: {},
      administrative_contributions: {},
      infrastructure_development: {},
      ...(IsOldReportYear(report) && { revenue_generated_through_training_program: {} }),
      research_or_academic_events: {},
      events_conducted: {},
      new_initiatives: {},
      resource_person_in_training_programmes: {},
      training_programmes_attended: {},
      participation_and_academic_contributions: {},
      overseas_visited_for_academic_events: {},
      participation_and_contributions: {},
      editor_in_chief: {},
      national_or_international_assignment: {},
      fellow_or_life_member: {},
    };
    validate.academic_year = NonEmptyValidation(report?.academic_year);
    if (!IsOldReportYear(report)) {
      validate.month = NonEmptyValidation(report?.month);
    }

    if (report?.academic_qualification) {
      report.academic_qualification.forEach((academic) => {
        const valide = {
          qualification: NonEmptyValidation(academic?.qualification),
        };
        validate.academic_qualification = {
          ...validate.academic_qualification,
          [academic.id.toString()]: valide,
        };
      });
    }
    if (report?.period_of_absence) {
      report.period_of_absence.forEach((period) => {
        const valide = {
          leave_type: NonEmptyValidation(period?.leave_type),
          no_of_days: NonEmptyValidation(period?.no_of_days),
        };
        validate.period_of_absence = {
          ...validate.period_of_absence,
          [period.id.toString()]: valide,
        };
      });
    }
    if (report?.non_sponsored_training) {
      report.non_sponsored_training.forEach((nonsponsored) => {
        const valide = {
          fdp_no: NonEmptyValidation(nonsponsored?.fdp_no),
          mode: NonEmptyValidation(nonsponsored?.mode),
          conducted_at: StringValidation(nonsponsored?.conducted_at),
          from_date: NonEmptyValidation(nonsponsored?.from_date),
          to_date: NonEmptyValidation(nonsponsored?.to_date),
          no_of_hours: NumberValidation(nonsponsored?.no_of_hours),
        };
        if (IsOldReportYear(report)) {
          valide.level = NonEmptyValidation(nonsponsored?.level);
        } else {
          valide.revenue_generated = NumberValidationw0(nonsponsored?.revenue_generated);
        }
        validate.non_sponsored_training = {
          ...validate.non_sponsored_training,
          [nonsponsored.id.toString()]: valide,
        };
      });
    }
    if (report?.sponsored_contact_mode) {
      report.sponsored_contact_mode.forEach((sponsored) => {
        const valide = {
          title: StringValidation(sponsored?.title),
          sponsored_agency: StringValidation(sponsored?.sponsored_agency),
          conducted_at: StringValidation(sponsored?.conducted_at),
          from_date: NonEmptyValidation(sponsored?.from_date),
          to_date: NonEmptyValidation(sponsored?.to_date),
          role: StringValidation(sponsored?.role),
          no_of_hours: NumberValidation(sponsored?.no_of_hours),
          level: NonEmptyValidation(sponsored?.level),
          amount: NumberValidationw0(sponsored?.amount),
        };
        if (!IsOldReportYear(report)) {
          valide.mode = StringValidation(sponsored?.mode)
        }
        validate.sponsored_contact_mode = {
          ...validate.sponsored_contact_mode,
          [sponsored.id.toString()]: valide,
        };
      });
    }
    if (report?.skill_development) {
      report.skill_development.forEach((skill) => {
        const valide = {
          title: StringValidation(skill?.title),
          sponsored_agency: StringValidation(skill?.sponsored_agency),
          conducted_at: StringValidation(skill?.conducted_at),
          from_date: NonEmptyValidation(skill?.from_date),
          to_date: NonEmptyValidation(skill?.to_date),
          role: StringValidation(skill?.role),
          no_of_hours: NumberValidation(skill?.no_of_hours),
          amount: NumberValidationw0(skill?.amount),
        };
        if (IsOldReportYear(report)) {
          valide.level = NonEmptyValidation(skill?.level);
        }
        validate.skill_development = {
          ...validate.skill_development,
          [skill.id.toString()]: valide,
        };
      });
    }
    if (report?.development_of_moocs) {
      report.development_of_moocs.forEach((develop) => {
        const valide = {
          title: StringValidation(develop?.title),
          time_taken: NonEmptyValidation(develop?.time_taken),
          platform: StringValidation(develop?.platform),
          coordinator_or_co_coordinator: NonEmptyValidation(develop?.coordinator_or_co_coordinator),
          used_for: StringValidation(develop?.used_for),
        };
        if (IsOldReportYear(report)) {
          valide.date_of_launch = NonEmptyValidation(develop?.date_of_launch);
        } else {
          valide.status = NonEmptyValidation(develop?.status);
          valide.from_date = NonEmptyValidation(develop?.from_date);
          valide.to_date = NonEmptyValidation(develop?.to_date);
        }
        validate.development_of_moocs = {
          ...validate.development_of_moocs,
          [develop.id.toString()]: valide,
        };
      });
    }
    if (report?.resource_person) {
      report.resource_person.forEach((resource) => {
        const valide = {
          fdp_no: NonEmptyValidation(resource?.fdp_no),
          mode: NonEmptyValidation(resource?.mode),
          conducted_at: StringValidation(resource?.conducted_at),
          from_date: NonEmptyValidation(resource?.from_date),
          to_date: NonEmptyValidation(resource?.to_date),
          no_of_hours: NumberValidation(resource?.no_of_hours),
        };
        if (IsOldReportYear(report)) {
          valide.level = NonEmptyValidation(resource?.level);
        } else {
          valide.course_type = NonEmptyValidation(resource?.course_type);
        }
        validate.resource_person = {
          ...validate.resource_person,
          [resource.id.toString()]: valide,
        };
      });
    }
    if (report?.development_of_training_manual) {
      report.development_of_training_manual.forEach((development) => {
        const valide = {
          author_name: StringValidation(development?.author_name),
          title: StringValidation(development?.title),
          type_of_publications: StringValidation(development?.type_of_publications),
          publisher_country: StringValidation(development?.publisher_country),
          publisher_year: YearValidation(development?.publisher_year),
          total_pages: NumberValidation(development?.total_pages),
        };
        validate.development_of_training_manual = {
          ...validate.development_of_training_manual,
          [development.id.toString()]: valide,
        };
      });
    }
    if (report?.courses_handled_for_pg_phd) {
      report.courses_handled_for_pg_phd.forEach((courses) => {
        const valide = {
          course_number_and_title: NonEmptyValidation(courses?.course_number_and_title),
          pg_or_phd: NonEmptyValidation(courses?.pg_or_phd),
          theory_or_laboratory: NonEmptyValidation(courses?.theory_or_laboratory),
          credit: NonEmptyValidation(courses?.credit),
          individual_or_shared: NonEmptyValidation(courses?.individual_or_shared),
        };
        if (IsOldReportYear(report)) {
          valide.university_or_institute = NonEmptyValidation(courses?.university_or_institute);
          valide.no_of_hours = NumberValidation(courses?.no_of_hours);
        } else {
          valide.from_date = NonEmptyValidation(courses?.from_date);
          valide.to_date = NonEmptyValidation(courses?.to_date);
        }
        validate.courses_handled_for_pg_phd = {
          ...validate.courses_handled_for_pg_phd,
          [courses.id.toString()]: valide,
        };
      });
    }
    if (report?.new_courses_developed_offered) {
      report.new_courses_developed_offered.forEach((newcourses) => {
        const valide = {
          course_number_and_title: NonEmptyValidation(newcourses?.course_number_and_title),
          pg_phd_or_fdp_level: NonEmptyValidation(newcourses?.pg_phd_or_fdp_level),
          theory_or_laboratory: NonEmptyValidation(newcourses?.theory_or_laboratory),
          credit: NonEmptyValidation(newcourses?.credit),
          individual_or_shared: NonEmptyValidation(newcourses?.individual_or_shared),
        };
        if (IsOldReportYear(report)) {
          valide.university_or_institute = NonEmptyValidation(newcourses?.university_or_institute);
          valide.no_of_times = NumberValidation(newcourses?.no_of_times)
        } else {
          valide.first_time_offered = NonEmptyValidation(newcourses?.first_time_offered)

        }
        validate.new_courses_developed_offered = {
          ...validate.new_courses_developed_offered,
          [newcourses.id.toString()]: valide,
        };
      });
    }
    if (report?.curriculum_developed_or_revised) {
      report.curriculum_developed_or_revised.forEach((curriculum) => {
        const valide = {
          client: NonEmptyValidation(curriculum?.client),
          amount: NumberValidationw0(curriculum?.amount),
        };
        if (IsOldReportYear(report)) {
          valide.curriculum_developed = {
            no_of_courses: NonEmptyValidation(curriculum?.curriculum_developed?.no_of_courses),
            no_of_programs: NonEmptyValidation(curriculum?.curriculum_developed?.no_of_programs)
          }
          valide.curriculum_revised = {
            no_of_courses: NonEmptyValidation(curriculum?.curriculum_revised?.no_of_courses),
            no_of_programs: NonEmptyValidation(curriculum?.curriculum_revised?.no_of_programs)
          }
        } else if (!IsOldReportYear(report)) {
          valide.developed_or_revised = NonEmptyValidation(curriculum?.developed_or_revised)
          valide.no_of_courses = NonEmptyValidation(curriculum?.no_of_courses)
        }
        validate.curriculum_developed_or_revised = {
          ...validate.curriculum_developed_or_revised,
          [curriculum.id.toString()]: valide,
        };
      });
    }
    if (report?.phd_research_guidances) {
      report.phd_research_guidances.forEach((phd) => {
        const valide = {
          name_of_the_student: StringValidation(phd?.name_of_the_student),
          title: StringValidation(phd?.title),
          affiliating_university: StringValidation(phd?.affiliating_university),
          year_of_completion: YearValidation(phd?.year_of_completion),
          supervisor_or_joint_supervisor: NonEmptyValidation(phd?.supervisor_or_joint_supervisor),
        };
        validate.phd_research_guidances = {
          ...validate.phd_research_guidances,
          [phd.id.toString()]: valide,
        };
      });
    }
    if (report?.post_graduate_thesis_guidances) {
      report.post_graduate_thesis_guidances.forEach((post) => {
        const valide = {
          name_of_the_student: StringValidation(post?.name_of_the_student),
          title: StringValidation(post?.title),
          affiliating_university: StringValidation(post?.affiliating_university),
          year_of_completion: YearValidation(post?.year_of_completion),
          supervisor_or_joint_supervisor: NonEmptyValidation(post?.supervisor_or_joint_supervisor),
        };
        validate.post_graduate_thesis_guidances = {
          ...validate.post_graduate_thesis_guidances,
          [post.id.toString()]: valide,
        };
      });
    }
    if (report?.sponsored_research_projects) {
      report.sponsored_research_projects.forEach((sponsoredre) => {
        const valide = {
          title: StringValidation(sponsoredre?.title),
          sponsored_agency: StringValidation(sponsoredre?.sponsored_agency),
          from_date: NonEmptyValidation(sponsoredre?.from_date),
          to_date: NonEmptyValidation(sponsoredre?.to_date),
          pi_or_co_pi: NonEmptyValidation(sponsoredre?.pi_or_co_pi),
          ongoing_or_submitted: NonEmptyValidation(sponsoredre?.ongoing_or_submitted),
          amount: NumberValidationw0(sponsoredre?.amount),
        };
        if (IsOldReportYear(report)) {
          valide.duration = NonEmptyValidation(sponsoredre?.duration);
          valide.research_consultancy = NonEmptyValidation(sponsoredre?.research_consultancy);
        }
        validate.sponsored_research_projects = {
          ...validate.sponsored_research_projects,
          [sponsoredre.id.toString()]: valide,
        };
      });
    }
    if (report?.consultancy_works_carried_out) {
      report.consultancy_works_carried_out.forEach((consult) => {
        const valide = {
          title: StringValidation(consult?.title),
          sponsored_agency: StringValidation(consult?.sponsored_agency),
          from_date: NonEmptyValidation(consult?.from_date),
          to_date: NonEmptyValidation(consult?.to_date),
          pi_or_co_pi: NonEmptyValidation(consult?.pi_or_co_pi),
          amount: NumberValidationw0(consult?.amount),
        };
        if (IsOldReportYear(report)) {
          valide.duration = NonEmptyValidation(consult?.duration);
          valide.research_consultancy = NonEmptyValidation(consult?.research_consultancy);
        }
        validate.consultancy_works_carried_out = {
          ...validate.consultancy_works_carried_out,
          [consult.id.toString()]: valide,
        };
      });
    }
    if (report?.research_publications) {
      report.research_publications.forEach((researchpublic) => {
        const valide = {
          author_name: NonEmptyValidation(researchpublic?.author_name),
          title: StringValidation(researchpublic?.title),
          name_of_journal: StringValidation(researchpublic?.name_of_journal),
          volume_no: NumberValidation(researchpublic?.volume_no),
          volume_issue: NonEmptyValidation(researchpublic?.volume_issue),
          year: YearValidation(researchpublic?.year),
          sci_scopus_ugc: NonEmptyValidation(researchpublic?.sci_scopus_ugc),
          impact_factor: NonEmptyValidation(researchpublic?.impact_factor),
          no_of_citations: NumberValidationw0(researchpublic?.no_of_citations),
        };
        validate.research_publications = {
          ...validate.research_publications,
          [researchpublic.id.toString()]: valide,
        };
      });
    }
    if (report?.papers_presentation) {
      report.papers_presentation.forEach((paperpresent) => {
        const valide = {
          author_name: StringValidation(paperpresent?.author_name),
          title: StringValidation(paperpresent?.title),
          name_of_the_event: StringValidation(paperpresent?.name_of_the_event),
          issn_volume: NonEmptyValidation(paperpresent?.issn_volume),
          page_no: NumberValidation(paperpresent?.page_no),
          year: YearValidation(paperpresent?.year),
          place: StringValidation(paperpresent?.place),
          country: StringValidation(paperpresent?.country),
        };
        validate.papers_presentation = {
          ...validate.papers_presentation,
          [paperpresent.id.toString()]: valide,
        };
      });
    }
    if (report?.books_authored) {
      report.books_authored.forEach((books) => {
        const valide = {
          author_name: StringValidation(books?.author_name),
          title: StringValidation(books?.title),
          type_of_publications: StringValidation(books?.type_of_publications),
          isbn_issn: NonEmptyValidation(books?.isbn_issn),
          publisher_country: StringValidation(books?.publisher_country),
          publisher_year: YearValidation(books?.publisher_year),
          total_pages: NumberValidation(books?.total_pages),
        };
        validate.books_authored = {
          ...validate.books_authored,
          [books.id.toString()]: valide,
        };
      });
    }
    if (report?.patents) {
      report.patents.forEach((patent) => {
        const valide = {
          title: StringValidation(patent?.title),
          type: NonEmptyValidation(patent?.type),
          registration_no: NonEmptyValidation(patent?.registration_no),
          registration_date: NonEmptyValidation(patent?.registration_date),
          granted_or_filed: NonEmptyValidation(patent?.granted_or_filed),
        };
        if (!IsOldReportYear(report)) {
          valide.level = NonEmptyValidation(patent?.level);
        }
        validate.patents = {
          ...validate.patents,
          [patent.id.toString()]: valide,
        };
      });
    }
    if (report?.awards_details) {
      report.awards_details.forEach((award) => {
        const valide = {
          name_of_the_award: StringValidation(award?.name_of_the_award),
          awarding_institution: StringValidation(award?.awarding_institution),
          area_of_recognition: StringValidation(award?.area_of_recognition),
          national_or_international: NonEmptyValidation(award?.national_or_international),
          year: YearValidation(award?.year),
        };
        validate.awards_details = {
          ...validate.awards_details,
          [award.id.toString()]: valide,
        };
      });
    }
    if (report?.administrative_contributions) {
      report.administrative_contributions.forEach((admincontribute) => {
        const valide = {
          position: StringValidation(admincontribute?.position),
          significant_contributions: StringValidation(admincontribute?.significant_contributions),
        };
        if (IsOldReportYear(report)) {
          valide.from_date = NonEmptyValidation(admincontribute?.from_date);
          valide.to_date = NonEmptyValidation(admincontribute?.to_date);
          valide.experience = NonEmptyValidation(admincontribute?.experience);
        }
        validate.administrative_contributions = {
          ...validate.administrative_contributions,
          [admincontribute.id.toString()]: valide,
        };
      });
    }
    if (report?.infrastructure_development) {
      report.infrastructure_development.forEach((infra) => {
        const valide = {
          type: NonEmptyValidation(infra?.type),
          others: infra?.type === "others" ? StringValidation(infra?.others) : { status: true, message: "" },
          funding_agency: StringValidation(infra?.funding_agency),
          from_date: NonEmptyValidation(infra?.from_date),
          to_date: NonEmptyValidation(infra?.to_date),
          pi_or_co_pi: NonEmptyValidation(infra?.pi_or_co_pi),
          salient_contributions: StringValidation(infra?.salient_contributions),
          amount: NumberValidationw0(infra?.amount),
        };
        validate.infrastructure_development = {
          ...validate.infrastructure_development,
          [infra.id.toString()]: valide,
        };
      });
    }
    if (IsOldReportYear(report)) {
      if (report?.revenue_generated_through_training_program) {
        report.revenue_generated_through_training_program.forEach((revenuegen) => {
          const valide = {
            academic_event: StringValidation(revenuegen?.academic_event),
            title_of_event: StringValidation(revenuegen?.title_of_event),
            national_or_international: NonEmptyValidation(revenuegen?.national_or_international),
            role: StringValidation(revenuegen?.role),
            amount: NumberValidationw0(revenuegen?.amount),
          };
          validate.revenue_generated_through_training_program = {
            ...validate.revenue_generated_through_training_program,
            [revenuegen.id.toString()]: valide,
          };
        });
      }
    }
    if (report?.research_or_academic_events) {
      report.research_or_academic_events.forEach((infra) => {
        const valide = {
          academic_event: StringValidation(infra?.academic_event),
          title_of_event: StringValidation(infra?.title_of_event),
          date: NonEmptyValidation(infra?.date),
          role: StringValidation(infra?.role),
          no_of_participants: NumberValidation(infra?.no_of_participants),
          national_or_international: NonEmptyValidation(infra?.national_or_international),
        };
        validate.research_or_academic_events = {
          ...validate.research_or_academic_events,
          [infra.id.toString()]: valide,
        };
      });
    }
    if (report?.events_conducted) {
      report.events_conducted.forEach((eventconduct) => {
        const valide = {
          title_of_event: StringValidation(eventconduct?.title_of_event),
          date: NonEmptyValidation(eventconduct?.date),
          role: StringValidation(eventconduct?.role),
          no_of_participants: NumberValidation(eventconduct?.no_of_participants),
          name_of_the_industry: StringValidation(eventconduct?.name_of_the_industry),
          revenue_generated: NumberValidationw0(eventconduct?.revenue_generated),
        };
        validate.events_conducted = {
          ...validate.events_conducted,
          [eventconduct.id.toString()]: valide,
        };
      });
    }
    if (report?.new_initiatives) {
      report.new_initiatives.forEach((newinit) => {
        const valide = {
          initiative_implemented: StringValidation(newinit?.initiative_implemented),
          type_of_benefit: StringValidation(newinit?.type_of_benefit),
          revenue_generated: NumberValidationw0(newinit?.revenue_generated),
          role: NonEmptyValidation(newinit?.role),
        };
        validate.new_initiatives = {
          ...validate.new_initiatives,
          [newinit.id.toString()]: valide,
        };
      });
    }
    if (report?.resource_person_in_training_programmes) {
      report.resource_person_in_training_programmes.forEach((resourceperson) => {
        const valide = {
          title: StringValidation(resourceperson?.title),
          mode: NonEmptyValidation(resourceperson?.mode),
          conducted_at: StringValidation(resourceperson?.conducted_at),
          from_date: NonEmptyValidation(resourceperson?.from_date),
          to_date: NonEmptyValidation(resourceperson?.to_date),
          no_of_hours: NumberValidation(resourceperson?.no_of_hours),
          level: NonEmptyValidation(resourceperson?.level),
        };
        validate.resource_person_in_training_programmes = {
          ...validate.resource_person_in_training_programmes,
          [resourceperson.id.toString()]: valide,
        };
      });
    }
    if (report?.training_programmes_attended) {
      report.training_programmes_attended.forEach((trainprogram) => {
        const valide = {
          title: StringValidation(trainprogram?.title),
          host_institution: StringValidation(trainprogram?.host_institution),
          sponsoring_agency: StringValidation(trainprogram?.sponsoring_agency),
          from_date: NonEmptyValidation(trainprogram?.from_date),
          to_date: NonEmptyValidation(trainprogram?.to_date),
          national_or_international: NonEmptyValidation(trainprogram?.national_or_international),
        };
        validate.training_programmes_attended = {
          ...validate.training_programmes_attended,
          [trainprogram.id.toString()]: valide,
        };
      });
    }
    if (report?.participation_and_academic_contributions) {
      report.participation_and_academic_contributions.forEach((participat) => {
        const valide = {
          assignment: NonEmptyValidation(participat?.assignment),
          organization: StringValidation(participat?.organization),
          nature_of_duty: StringValidation(participat?.nature_of_duty),
          from_date: NonEmptyValidation(participat?.from_date),
          to_date: NonEmptyValidation(participat?.to_date),
          level: NonEmptyValidation(participat?.level),
        };
        if (IsOldReportYear(report)) {
          valide.experience = NonEmptyValidation(participat?.experience);
        }
        validate.participation_and_academic_contributions = {
          ...validate.participation_and_academic_contributions,
          [participat.id.toString()]: valide,
        };
      });
    }
    if (report?.overseas_visited_for_academic_events) {
      report.overseas_visited_for_academic_events.forEach((overseas) => {
        const valide = {
          organization_or_university: StringValidation(overseas?.organization_or_university),
          city: StringValidation(overseas?.city),
          country: StringValidation(overseas?.country),
          institution_sponsored: StringValidation(overseas?.institution_sponsored),
          nature_of_visit: StringValidation(overseas?.nature_of_visit),
          from_date: NonEmptyValidation(overseas?.from_date),
          to_date: NonEmptyValidation(overseas?.to_date),
        };
        if (IsOldReportYear(report)) {
          valide.duration = NonEmptyValidation(overseas?.duration);
        }
        validate.overseas_visited_for_academic_events = {
          ...validate.overseas_visited_for_academic_events,
          [overseas.id.toString()]: valide,
        };
      });
    }
    if (report?.participation_and_contributions) {
      report.participation_and_contributions.forEach((parti) => {
        const valide = {
          details: NonEmptyValidation(parti?.details),
          from_date: NonEmptyValidation(parti?.from_date),
          to_date: NonEmptyValidation(parti?.to_date),
        };
        if (IsOldReportYear(report)) {
          valide.duration = NonEmptyValidation(parti?.duration);
        }
        validate.participation_and_contributions = {
          ...validate.participation_and_contributions,
          [parti.id.toString()]: valide,
        };
      });
    }
    if (report?.editor_in_chief) {
      report.editor_in_chief.forEach((edit) => {
        const valide = {
          role: StringValidation(edit?.role),
          title_of_journal: StringValidation(edit?.title_of_journal),
          journal_publisher: StringValidation(edit?.journal_publisher),
          issn: NonEmptyValidation(edit?.issn),
          year: YearValidation(edit?.year),
        };
        validate.editor_in_chief = {
          ...validate.editor_in_chief,
          [edit.id.toString()]: valide,
        };
      });
    }
    if (report?.national_or_international_assignment) {
      report.national_or_international_assignment.forEach((nationalassign) => {
        const valide = {
          type: NonEmptyValidation(nationalassign?.type),
          level: NonEmptyValidation(nationalassign?.level),
          nature_of_assignment: StringValidation(nationalassign?.nature_of_assignment),
          from_date: NonEmptyValidation(nationalassign?.from_date),
          to_date: NonEmptyValidation(nationalassign?.to_date),
          duration: DurationValidation(nationalassign?.duration),
        };
        validate.national_or_international_assignment = {
          ...validate.national_or_international_assignment,
          [nationalassign.id.toString()]: valide,
        };
      });
    }
    if (report?.fellow_or_life_member) {
      report.fellow_or_life_member.forEach((fellow) => {
        const valide = {
          name: StringValidation(fellow?.name),
          type: NonEmptyValidation(fellow?.type),
          level: NonEmptyValidation(fellow?.level),
          registration_no: NonEmptyValidation(fellow?.registration_no),
          registration_year: YearValidation(fellow?.registration_year),
        };
        validate.fellow_or_life_member = {
          ...validate.fellow_or_life_member,
          [fellow.id.toString()]: valide,
        };
      });
    }

    setValidation(validate);
    if (checkAllStatusTrue(validate) === true) {
      const Payload = {
        ...report,
        month: report?.month?.value || 0,
        academic_year: (!isSpecific ? report?.academic_year : ((report?.academic_year === 2024 && report?.month?.value > 3) ? (report?.academic_year + '-' + (report?.academic_year + 1)) : report?.academic_year))
      };

      !IsOldReportYear(report) && delete Payload?.revenue_generated_through_training_program
      {
        isSpecific &&
          delete Payload.employee_id;
        Payload?.period_of_absence?.map((a) => (
          delete a.leave
        ))
        delete Payload.name;
        delete Payload.dob;
        delete Payload.fathers_name;
        delete Payload.designation_id;
        delete Payload.pay_level;
        delete Payload.department_id;
        delete Payload.total_amount_for_consultancy_works_carried_out;
        delete Payload.total_amount_for_infrastructure_development;
        delete Payload.total_amount_for_revenue_generated_through_training_program;
        delete Payload.total_amount_for_sponsored_research_projects;
        delete Payload.total_amount_recieved_for_skill_development;
        delete Payload.total_amount_recieved_for_sponsored_contact_mode;
        delete Payload.total_no_of_hours_for_pg_phd_courses_handled;
        delete Payload.total_no_of_hours_for_resource_person;
        delete Payload.total_no_of_hours_for_resource_person_in_training_programmes;
        delete Payload.is_deleted;
        delete Payload.created_at;
        delete Payload.created_by;
        delete Payload.updated_at;
        delete Payload.updated_by;
        delete Payload.non_sponsored_training_total_revenue;
        delete Payload?.editable;
        delete Payload?.department;
        delete Payload?.designation;
        delete Payload?.hod_comment;
        delete Payload?.hod_status;
        delete Payload?.hod_declaration;
      }
      const modifiedData = removeIdAndEmptyObjects(Payload);
      let response
      response = (key === 'submit' ? await CreateStaffReport(modifiedData, token) : await CreateStaffReportTemporary(modifiedData, token))
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        navigate(-1);
        setStatusAcceptModel(false);
      } else {
        errorMsg(response.message);
      }
    } else {
      setStatusAcceptModel(false);
      errorMsg('Check All the parts')
      setClick(true)
    }
  };
  if (click === true && dummyarray.length > 0) {
    const checkYear = validation?.academic_year?.status
    const checkmonth = validation?.month ? validation?.month?.status : true
    if (checkYear === false) {
      inputRef.current[dummyarray[0]].focus()
    }
    if (checkmonth === false) {
      inputRef.current[dummyarray[0]].focus()
    }
    if (checkYear && checkmonth && active === 0) {
      inputRefA.current[dummyarray[0]].focus()
    }
    if (checkYear && checkmonth && active === 1) {
      const element = inputRefB.current[dummyarray[0]]
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        element.focus({ preventScroll: true })
      }
    }
    if (checkYear && checkmonth && active === 2) {
      const element = inputRefC.current[dummyarray[0]]
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        element.focus({ preventScroll: true })
      }
    }
    if (checkYear && checkmonth && active === 3) {
      const element = inputRefD.current[dummyarray[0]]
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        element.focus({ preventScroll: true })
      }
    }
    if (checkYear && checkmonth && active === 4) {
      const element = inputRefE.current[dummyarray[0]]
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        element.focus({ preventScroll: true })
      }
    }


    setClick(false)
  }
  if (!IsOldReportYear(report)) {
    if (report && report.non_sponsored_training && report.non_sponsored_training[0]) {
      delete report?.non_sponsored_training[0]?.level
      report.non_sponsored_training[0].revenue_generated = report.non_sponsored_training[0].revenue_generated || "";
    }
    delete report?.skill_development[0]?.level
    if (report && report.development_of_moocs && report.development_of_moocs[0]) {
      delete report.development_of_moocs[0].date_of_launch;
      report.development_of_moocs[0].from_date = report.development_of_moocs[0].from_date || "";
      report.development_of_moocs[0].to_date = report.development_of_moocs[0].to_date || "";
      report.development_of_moocs[0].status = report.development_of_moocs[0].status || "";
    }
    if (report && report.resource_person && report.resource_person[0]) {
      delete report.resource_person[0].level;
      report.resource_person[0].course_type = report.resource_person[0].course_type || "";
    }
    if (report && report.courses_handled_for_pg_phd && report.courses_handled_for_pg_phd[0]) {
      delete report.courses_handled_for_pg_phd[0].university_or_institute;
      delete report.courses_handled_for_pg_phd[0].no_of_hours;
      report.courses_handled_for_pg_phd[0].from_date = report.courses_handled_for_pg_phd[0].from_date || "";
      report.courses_handled_for_pg_phd[0].to_date = report.courses_handled_for_pg_phd[0].to_date || "";
    }
    if (report && report.new_courses_developed_offered && report.new_courses_developed_offered[0]) {
      delete report.new_courses_developed_offered[0].university_or_institute;
      delete report.new_courses_developed_offered[0].no_of_times;
      report.new_courses_developed_offered[0].first_time_offered = report.new_courses_developed_offered[0].first_time_offered || "";
    }
    if (report && report.curriculum_developed_or_revised && report.curriculum_developed_or_revised[0]) {
      delete report.curriculum_developed_or_revised[0].curriculum_developed;
      delete report.curriculum_developed_or_revised[0].curriculum_revised;
      report.curriculum_developed_or_revised[0].developed_or_revised = report.curriculum_developed_or_revised[0].developed_or_revised || "";
      report.curriculum_developed_or_revised[0].no_of_courses = report.curriculum_developed_or_revised[0].no_of_courses || "";
    }
    if (report && report.sponsored_research_projects && report.sponsored_research_projects[0]) {
      delete report.sponsored_research_projects[0].duration;
      delete report.sponsored_research_projects[0].research_consultancy;
    }
    if (report && report.consultancy_works_carried_out && report.consultancy_works_carried_out[0]) {
      delete report.consultancy_works_carried_out[0].duration;
      delete report.consultancy_works_carried_out[0].research_consultancy;
    }
    if (report && report.patents && report.patents[0]) {
      report.patents[0].level = report.patents[0].level || "";
    }
    if (report && report.administrative_contributions && report.administrative_contributions[0]) {
      delete report.administrative_contributions[0].from_date;
      delete report.administrative_contributions[0].to_date;
      delete report.administrative_contributions[0].experience;
    }

    if (report && report.participation_and_academic_contributions && report.participation_and_academic_contributions[0]) {
      delete report.participation_and_academic_contributions[0].experience;
    }
    if (report && report.overseas_visited_for_academic_events && report.overseas_visited_for_academic_events[0]) {
      delete report.overseas_visited_for_academic_events[0].duration;
    }
    if (report && report.participation_and_contributions && report.participation_and_contributions[0]) {
      delete report.participation_and_contributions[0].duration;
    }
  } else {
    if (report && report.non_sponsored_training && report.non_sponsored_training[0]) {
      delete report?.non_sponsored_training[0]?.revenue_generated
      report.non_sponsored_training[0].level = report.non_sponsored_training[0].level || "";
    }
    delete report?.sponsored_contact_mode[0]?.mode
    if (report && report.development_of_moocs && report.development_of_moocs[0]) {
      delete report?.development_of_moocs[0]?.status
      delete report?.development_of_moocs[0]?.from_date
      delete report?.development_of_moocs[0]?.to_date
      report.development_of_moocs[0].date_of_launch = report.development_of_moocs[0].date_of_launch || "";

    }
    if (report && report.resource_person && report.resource_person[0]) {
      delete report.resource_person[0].course_type;
      report.resource_person[0].level = report.resource_person[0].level || "";
    }
    if (report && report.courses_handled_for_pg_phd && report.courses_handled_for_pg_phd[0]) {
      delete report.courses_handled_for_pg_phd[0].from_date;
      delete report.courses_handled_for_pg_phd[0].to_date;
      report.courses_handled_for_pg_phd[0].university_or_institute = report.courses_handled_for_pg_phd[0].university_or_institute || "";
      report.courses_handled_for_pg_phd[0].no_of_hours = report.courses_handled_for_pg_phd[0].no_of_hours || "";
    }
    if (report && report.new_courses_developed_offered && report.new_courses_developed_offered[0]) {
      report.new_courses_developed_offered[0].university_or_institute = report.new_courses_developed_offered[0].university_or_institute || "";
      report.new_courses_developed_offered[0].no_of_times = report.new_courses_developed_offered[0].no_of_times || "";
      delete report.new_courses_developed_offered[0].first_time_offered;

    }
    if (report && report.curriculum_developed_or_revised && report.curriculum_developed_or_revised[0]) {
      delete report.curriculum_developed_or_revised[0].developed_or_revised;
      delete report.curriculum_developed_or_revised[0].no_of_courses;


      report.curriculum_developed_or_revised[0].curriculum_developed = {
        no_of_programs: report?.curriculum_developed_or_revised[0]?.curriculum_developed?.no_of_programs || "",
        no_of_courses: report?.curriculum_developed_or_revised[0]?.curriculum_developed?.no_of_courses || "",
      };
      report.curriculum_developed_or_revised[0].curriculum_revised = {
        no_of_programs: report?.curriculum_developed_or_revised[0]?.curriculum_revised?.no_of_programs || "",
        no_of_courses: report?.curriculum_developed_or_revised[0]?.curriculum_revised?.no_of_courses || "",
      };
    }
    if (report && report.sponsored_research_projects && report.sponsored_research_projects[0]) {
      report.sponsored_research_projects[0].duration = report.sponsored_research_projects[0].duration || "";
      report.sponsored_research_projects[0].research_consultancy = report.sponsored_research_projects[0].research_consultancy || "";
    }
    if (report && report.consultancy_works_carried_out && report.consultancy_works_carried_out[0]) {
      report.consultancy_works_carried_out[0].duration = report.consultancy_works_carried_out[0].duration || "";
      report.consultancy_works_carried_out[0].research_consultancy = report.consultancy_works_carried_out[0].research_consultancy || "";
    }
    if (report && report.patents && report.patents[0]) {
      delete report.patents[0].level;
    }
    if (report && report.administrative_contributions && report.administrative_contributions[0]) {
      report.administrative_contributions[0].from_date = report.administrative_contributions[0].from_date || "";
      report.administrative_contributions[0].to_date = report.administrative_contributions[0].to_date || "";
      report.administrative_contributions[0].experience = report.administrative_contributions[0].experience || "";
    }
    if (report && report.participation_and_academic_contributions && report.participation_and_academic_contributions[0]) {
      report.participation_and_academic_contributions[0].experience = report.participation_and_academic_contributions[0].experience || "";
    }
    if (report && report.participation_and_contributions && report.participation_and_contributions[0]) {
      report.participation_and_contributions[0].duration = report.participation_and_contributions[0].duration || "";
    }
  }


  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <form>
                  <div className="row">
                    <div className="col-lg-4 my-auto">
                      <h6 className="labeltitle">
                        <span
                          className="arrowicon"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          ← &nbsp;
                        </span>
                        Appraisal Report
                      </h6>
                    </div>
                    <div className="col-lg-4 my-auto">
                      <div>
                        <label className="labeltext">Select a Year</label>
                        {!isSpecific ?
                          <ReactSelect
                            ref={el => inputRef.current['academic_year'] = el}
                            isMulti={false}
                            value={{
                              label: report.academic_year,
                              value: report.academic_year,
                            }}
                            onChange={(selectedOption) => {
                              setNormalData(selectedOption.value, "academic_year")
                            }}
                            options={FinancialYearOptions()}
                          />
                          :
                          <input
                            className="fieldinput"
                            disabled
                            value={FinancialYearView(report?.month, report?.academic_year)}
                          />
                        }
                      </div>
                      <small className="validationerror">{validation?.academic_year?.message ? `Year ${validation?.academic_year?.message}` : ""}</small>
                    </div>
                    {!IsOldReportYr(report) ? (
                      <div className="col-lg-4 my-auto">
                        <div>
                          <label className="labeltext">Select Month</label>
                          <ReactSelect
                            ref={el => inputRef.current['month'] = el}
                            isMulti={false}
                            isDisabled={isSpecific === true ? true : false}
                            value={report?.month}
                            onChange={(e) => {
                              setNormalData(e, "month");
                            }}
                            options={FinancialMonthOptions(report)}
                          />
                        </div>
                        <small className="validationerror">{validation?.month?.message ? `Month ${validation?.month?.message}` : ""}</small>
                      </div>
                    ) : (
                      <div className="col-lg-4 my-auto displaynone">
                        <input
                          id='months'
                          type="text"
                          placeholder="Enter count"
                          className="fieldinput"
                          defaultValue={report?.months ?? 0}
                          onChange={(e) => {
                            setNormalData(e, "months");
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="mt-5">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li onClick={() => showSelected(index)} key={link} className={active === index ? "agenttextactive" : "agenttextinactive"}>
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  {report?.editable === false ?
                    <AppraisalReportSpecificView
                      report={report}
                      active={active}
                      isEmployee={true}
                    />
                    :
                    <>
                      {active === 0 && (
                        <>
                          <h5 className="centertext my-5"> GENERAL INFORMATION </h5>
                          <div className="row mt-5">
                            <div className="col-lg-4 col-md-5">
                              <h6>1. Name</h6>
                            </div>
                            <div className="col-lg-1 p-0">:</div>
                            <div className="col-lg-5">
                              <h6>{first_name}</h6>
                            </div>
                          </div>
                          <div className="row my-4">
                            <div className="col-lg-4">
                              <h6>2. Date of Birth</h6>
                            </div>
                            <div className="col-lg-1 p-0">:</div>
                            <div className="col-lg-5">
                              <h6>{moment(dob).format("DD-MM-yyyy")}</h6>
                            </div>
                          </div>
                          <div className="row my-4">
                            <div className="col-lg-4">
                              <h6>3. Father's Name</h6>
                            </div>
                            <div className="col-lg-1 p-0">:</div>
                            <div className="col-lg-5">
                              <h6>{father_name}</h6>
                            </div>
                          </div>
                          <div className="row my-4">
                            <div className="col-lg-4">
                              <h6>4. Name of the Department / Centre / Extension Centre</h6>
                            </div>
                            <div className="col-lg-1 p-0">:</div>
                            <div className="col-lg-5">
                              <h6>{department}</h6>
                            </div>
                          </div>
                          <div className="row my-4">
                            <div className="col-lg-4">
                              <h6>5. Current Designation & Scale of Pay</h6>
                            </div>
                            <div className="col-lg-1 p-0">:</div>
                            <div className="col-lg-5">
                              <h6>
                                {desingation} & {pay_level}
                              </h6>
                            </div>
                          </div>
                          {report?.academic_qualification?.map((academic, index) => (
                            <div className="row my-4" key={academic.id}>
                              <div className="col-lg-4">
                                <h6>6. Academic Qualification obtained during the Assessment Period</h6>
                              </div>
                              <div className="col-lg-1 p-0">:</div>
                              <div className="col-lg-3">
                                <div>
                                  <input
                                    ref={el => inputRefA.current[`academic_qualification_qualification_${index}`] = el}
                                    type="text"
                                    key={index}
                                    className="fieldinputreport"
                                    placeholder="Enter Qualification"
                                    defaultValue={academic?.qualification}
                                    onChange={(e) => setData(e.target.value, "academic_qualification", "qualification", index)} />
                                </div>
                                <small className="validationerror">{validation?.academic_qualification[academic.id.toString()]?.qualification?.message ? `Qualification ${validation?.academic_qualification[academic.id.toString()]?.qualification?.message}` : ""}</small>
                              </div>
                              <div className="col-lg-3">
                                <div>
                                  <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "academic_qualification", "attachment", index)} accept="application/pdf" />
                                  <br />
                                  <small className="d-flex">Max File upload:200kb</small>
                                  <br />
                                  {academic?.attachment ? (
                                    <span
                                      className="namelink"
                                      onClick={() => {


                                        window.open(`${imagepath}${academic?.attachment}`, "_blank");
                                      }}
                                    >
                                      View Document
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-1">
                                <div>
                                  {report?.academic_qualification?.length - 1 === index && (
                                    <span
                                      className="material-symbols-outlined addoption"
                                      type="button"
                                      onClick={() => {
                                        setAddArrayData("academic_qualification", index);
                                      }}
                                    >
                                      add
                                    </span>
                                  )}
                                  {report?.academic_qualification?.length !== 1 && (
                                    <span
                                      className="material-symbols-outlined removeoption"
                                      type="button"
                                      onClick={() => {
                                        setRemoveArrayData("academic_qualification", index);
                                      }}
                                    >
                                      remove
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                          {report?.period_of_absence?.map((period, index) => (
                            <div className="row my-4" key={period.id}>
                              <div className="col-lg-4">
                                <h6>7. Period of absence from duty during the year (Leave)</h6>
                              </div>
                              <div className="col-lg-1 p-0">:</div>
                              <div className="col-lg-3">
                                <div>
                                  {isSpecific ?
                                    <select
                                      ref={el => inputRefA.current[`period_of_absence_leave_type_${index}`] = el}
                                      className="fieldinputreport"
                                      value={period.leave_type}
                                      onChange={(e) => {
                                        setData(e.target.value, "period_of_absence", "leave_type", index)
                                      }}>
                                      <option value="">Select Leave Type</option>
                                      {leaveType.map((item, i) => (
                                        <option value={item?.value}>{item.label}</option>
                                      ))}
                                    </select>
                                    :
                                    <select
                                      ref={el => inputRefA.current[`period_of_absence_leave_type_${index}`] = el}
                                      className="fieldinputreport"
                                      defaultValue={period.leave_type}
                                      onChange={(e) => setData(e.target.value, "period_of_absence", "leave_type", index)}
                                    >
                                      <option value="">Select Leave Type</option>
                                      {leaveType.map((item, i) => (
                                        <option value={item?.value}>{item.label}</option>
                                      ))}
                                    </select>
                                  }
                                </div>
                                <small className="validationerror">{validation?.period_of_absence[period.id.toString()]?.leave_type?.message ? `Leave Type ${validation?.period_of_absence[period.id.toString()]?.leave_type?.message}` : ""}</small>
                              </div>
                              <div className="col-lg-3">
                                <div>
                                  <input
                                    id='academic_year'
                                    type="number"
                                    ref={el => inputRefA.current[`period_of_absence_no_of_days_${index}`] = el}
                                    key={index} className="fieldinputreport" placeholder="Enter No of Days" defaultValue={period?.no_of_days} onChange={(e) => setData(e.target.value, "period_of_absence", "no_of_days", index)} />
                                </div>
                                <small className="validationerror">{validation?.period_of_absence[period.id.toString()]?.no_of_days?.message ? `Days ${validation?.period_of_absence[period.id.toString()]?.no_of_days?.message}` : ""}</small>
                              </div>
                              <div className="col-lg-1">
                                <div>
                                  {report?.period_of_absence?.length - 1 === index && (
                                    <span
                                      className="material-symbols-outlined addoption"
                                      type="button"
                                      onClick={() => {
                                        setAddArrayData("period_of_absence", index);
                                      }}
                                    >
                                      add
                                    </span>
                                  )}
                                  {report?.period_of_absence?.length !== 1 && (
                                    <span
                                      className="material-symbols-outlined removeoption"
                                      type="button"
                                      onClick={() => {
                                        setRemoveArrayData("period_of_absence", index);
                                      }}
                                    >
                                      remove
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                      {active === 1 && (
                        <>
                          <h5 className="centertext my-5">ACADEMIC CONTRIBUTIONS</h5>
                          <div>
                            <div>
                              <h6 className="reporttitle">
                                a. Grant in aid Training Programmes to be conducted as Coordinator :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.non_sponsored_training?.length}
                                    onChange={(yes) => {
                                      handle("non_sponsored_training", "yes", {
                                        id: 0,
                                        fdp_no: "",
                                        mode: "",
                                        conducted_at: "",
                                        from_date: "",
                                        to_date: "",
                                        no_of_hours: "",
                                        ...(IsOldReportYear(report) ? { level: "" } : { revenue_generated: "" }),
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.non_sponsored_training?.length}
                                    onChange={(no) => {
                                      handle("non_sponsored_training", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.non_sponsored_training?.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">{IsOldReportYear(report) ? "FDP.No" : "PDP.No"}</th>
                                        <th scope="col">Mode</th>
                                        <th scope="col">Conducted at</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">No.of Hours Handled</th>
                                        <th scope="col">
                                          {IsOldReportYear(report) ? "Level" : "Revenue Generated(in Rs)"}
                                        </th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.non_sponsored_training?.map((nonsponsored, index) => {
                                        return (
                                          <tr key={nonsponsored?.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`non_sponsored_training_fdp_no_${index}`] = el}
                                                  id={`non_sponsored_training_fdp_no_${index}`} key={index} type="text" className="fieldinputreport" placeholder={IsOldReportYear(report) ? "Enter FDP No" : 'Enter PDP No'} defaultValue={nonsponsored?.fdp_no} onChange={(e) => setData(e.target.value, "non_sponsored_training", "fdp_no", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.non_sponsored_training[nonsponsored?.id?.toString()]?.fdp_no?.message ? `${IsOldReportYear(report) ? "FDP No" : 'PDP No'} ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.fdp_no?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`non_sponsored_training_mode_${index}`] = el}
                                                  id={`non_sponsored_training_mode_${index}`} key={index} className="fieldinputselectreport" defaultValue={nonsponsored?.mode} onChange={(e) => setData(e.target.value, "non_sponsored_training", "mode", index)}>
                                                  <option value="">Select Mode</option>
                                                  <option value="contact">Contact</option>
                                                  <option value="online">Online</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.non_sponsored_training[nonsponsored.id.toString()]?.mode?.message ? `Mode ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.mode?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`non_sponsored_training_conducted_at_${index}`] = el}
                                                  id={`non_sponsored_training_conducted_at_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter Conducted At" defaultValue={nonsponsored?.conducted_at} onChange={(e) => setData(e.target.value, "non_sponsored_training", "conducted_at", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.non_sponsored_training[nonsponsored.id.toString()]?.conducted_at?.message ? `Conducted At ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.conducted_at?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb-5 pb-2" >
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`non_sponsored_training_from_date_${index}`] = el}
                                                    id={`non_sponsored_training_from_date_${index}`} type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={nonsponsored?.from_date} onChange={(e) => setData(e.target.value, "non_sponsored_training", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.non_sponsored_training[nonsponsored?.id?.toString()]?.from_date?.message ? `From Date ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`non_sponsored_training_to_date_${index}`] = el}
                                                    id={`non_sponsored_training_to_date_${index}`} type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={nonsponsored?.to_date} onChange={(e) => setData(e.target.value, "non_sponsored_training", "to_date", index)} min={moment(nonsponsored?.from_date).format("yyyy-MM-DD")} />
                                                </div>
                                                <small className="validationerror">{validation?.non_sponsored_training[nonsponsored.id.toString()]?.to_date?.message ? `To Date ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`non_sponsored_training_no_of_hours_${index}`] = el}
                                                  id={`non_sponsored_training_no_of_hours_${index}`} key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={nonsponsored?.no_of_hours} onChange={(e) => setData(e.target.value, "non_sponsored_training", "no_of_hours", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.non_sponsored_training[nonsponsored.id.toString()]?.no_of_hours?.message ? `Hours Handled ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.no_of_hours?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) ?
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefB.current[`non_sponsored_training_level_${index}`] = el}
                                                    id={`non_sponsored_training_level_${index}`} key={index} className="fieldinputselectreport" defaultValue={nonsponsored?.level} onChange={(e) => setData(e.target.value, "non_sponsored_training", "level", index)}>
                                                    <option value="">Select Level</option>
                                                    <option value="national">National</option>
                                                    <option value="regional">Regional</option>
                                                    <option value="state">State</option>
                                                  </select>
                                                </div>
                                                <small className="validationerror">{validation?.non_sponsored_training[nonsponsored.id.toString()]?.level?.message ? `Level ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.level?.message}` : ""}</small>
                                              </td> :
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`non_sponsored_training_revenue_generated_${index}`] = el}
                                                    key={index}
                                                    id={`non_sponsored_training_revenue_generated_${index}`}
                                                    type="number"
                                                    className="fieldinputreport"
                                                    placeholder="Enter Generated Revenue"
                                                    defaultValue={nonsponsored?.revenue_generated}
                                                    onChange={(e) => {
                                                      setData(e.target.value, "non_sponsored_training", "revenue_generated", index)
                                                    }
                                                    }
                                                  />
                                                </div>
                                                <small className="validationerror">
                                                  {validation?.non_sponsored_training[nonsponsored.id.toString()]?.revenue_generated?.message ?
                                                    `Generated Revenue ${validation?.non_sponsored_training[nonsponsored.id.toString()]?.revenue_generated?.message}` : ""}
                                                </small>
                                              </td>
                                            }
                                            <td>
                                              <input
                                                key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "non_sponsored_training", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {nonsponsored?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${nonsponsored?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.non_sponsored_training?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("non_sponsored_training", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.non_sponsored_training?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("non_sponsored_training", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      {!IsOldReportYear(report) &&
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td>Total Generated Revenue</td>
                                          <td>
                                            {calculateSum(report?.non_sponsored_training, 'revenue_generated')}
                                          </td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                b. Sponsored Contact mode Training Programmers conducted as Coordinator/ Co-coordinator (Funded by State/Central Government or ITEC) :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.sponsored_contact_mode?.length}
                                    onChange={(yes) => {
                                      handle("sponsored_contact_mode", "yes", {
                                        id: 0,
                                        title: "",
                                        ...(IsOldReportYear(report) ? "" : { mode: '' }),
                                        sponsored_agency: "",
                                        conducted_at: "",
                                        from_date: "",
                                        to_date: "",
                                        role: "",
                                        no_of_hours: "",
                                        level: "",
                                        amount: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.sponsored_contact_mode?.length}
                                    onChange={(no) => {
                                      handle("sponsored_contact_mode", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.sponsored_contact_mode?.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Title of the Programme</th>
                                        {IsOldReportYear(report) ? '' :
                                          <th scope="col">Mode</th>
                                        }
                                        <th scope="col">Sponsoring Agency</th>
                                        <th scope="col">Conducted at</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">Role</th>
                                        <th scope="col">
                                          No.of Hours <br /> Handled
                                        </th>
                                        <th scope="col">Level</th>
                                        <th scope="col">
                                          Amount of Grant <br /> (Rs. in Lakhs)
                                        </th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.sponsored_contact_mode?.map((sponsored, index) => {
                                        return (
                                          <tr key={sponsored.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`sponsored_contact_mode_title_${index}`] = el}
                                                  id={`sponsored_contact_mode_title_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter program title" defaultValue={sponsored?.title} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.title?.message ? `Program Title ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) ? '' :
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefB.current[`sponsored_contact_mode_mode_${index}`] = el}
                                                    id={`sponsored_contact_mode_mode_${index}`} key={index} className="fieldinputselectreport" defaultValue={sponsored?.mode} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "mode", index)}>
                                                    <option value="">Select Mode</option>
                                                    <option value="contact">Contact</option>
                                                    <option value="online">Online</option>
                                                  </select>
                                                </div>
                                                <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.mode?.message ? `Mode ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.mode?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`sponsored_contact_mode_sponsored_agency_${index}`] = el}
                                                  id={`sponsored_contact_mode_sponsored_agency_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter Sponsoring Agency" defaultValue={sponsored?.sponsored_agency} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "sponsored_agency", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.sponsored_agency?.message ? `Sponsored Agency ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.sponsored_agency?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`sponsored_contact_mode_conducted_at_${index}`] = el}
                                                  id={`sponsored_contact_mode_conducted_at_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter Conducted At" defaultValue={sponsored?.conducted_at} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "conducted_at", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.conducted_at?.message ? `Conducted At ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.conducted_at?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`sponsored_contact_mode_from_date_${index}`] = el}
                                                    id={`sponsored_contact_mode_from_date_${index}`} type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={sponsored?.from_date} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.from_date?.message ? `From Date ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`sponsored_contact_mode_to_date_${index}`] = el}
                                                    id={`sponsored_contact_mode_to_date_${index}`} type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={sponsored?.to_date} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "to_date", index)} min={moment(sponsored?.from_date).format("yyyy-MM-DD")} />
                                                </div>
                                                <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.to_date?.message ? `To Date ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`sponsored_contact_mode_role_${index}`] = el}
                                                  id={`sponsored_contact_mode_role_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter Role" defaultValue={sponsored?.role} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "role", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.role?.message ? `Role ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.role?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`sponsored_contact_mode_no_of_hours_${index}`] = el}
                                                  id={`sponsored_contact_mode_no_of_hours_${index}`} key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={sponsored?.no_of_hours} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "no_of_hours", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.no_of_hours?.message ? `Hours Handled ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.no_of_hours?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`sponsored_contact_mode_level_${index}`] = el}
                                                  id={`sponsored_contact_mode_level_${index}`} key={index} className="fieldinputselectreport" defaultValue={sponsored?.level} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "level", index)}>
                                                  <option value="">Select Level</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.level?.message ? `Level ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.level?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`sponsored_contact_mode_amount_${index}`] = el}
                                                  id={`sponsored_contact_mode_amount_${index}`} key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Amount" defaultValue={sponsored?.amount} onChange={(e) => setData(e.target.value, "sponsored_contact_mode", "amount", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_contact_mode[sponsored.id.toString()]?.amount?.message ? `Amount ${validation?.sponsored_contact_mode[sponsored.id.toString()]?.amount?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "sponsored_contact_mode", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {sponsored?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${sponsored?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.sponsored_contact_mode?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("sponsored_contact_mode", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.sponsored_contact_mode?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("sponsored_contact_mode", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        {!IsOldReportYear(report) && <td></td>}
                                        <td></td>
                                        <td></td>
                                        <td>Total Grants Received</td>
                                        <td>
                                          {calculateSum(report?.sponsored_contact_mode, 'amount')}
                                        </td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                c. Skill Development / Industrial Training Programmers conducted as Coordinator/ Co-coordinator :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.skill_development.length}
                                    onChange={(yes) => {
                                      handle("skill_development", "yes", {
                                        id: 0,
                                        title: "",
                                        sponsored_agency: "",
                                        conducted_at: "",
                                        from_date: "",
                                        to_date: "",
                                        role: "",
                                        no_of_hours: "",
                                        ...(IsOldReportYear(report) ? { level: "" } : ''),
                                        amount: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.skill_development.length}
                                    onChange={(no) => {
                                      handle("skill_development", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.skill_development.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Title of the Programme</th>
                                        <th scope="col">Sponsoring Agency</th>
                                        <th scope="col">Conducted at</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">Role</th>
                                        <th scope="col">
                                          No.of Hours <br /> Handled
                                        </th>
                                        {IsOldReportYear(report) ?
                                          <th scope="col">Level</th> : ''
                                        }
                                        <th scope="col">
                                          Amount of Grant <br /> (Rs. in Lakhs)
                                        </th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.skill_development?.map((skill, index) => {
                                        return (
                                          <tr key={skill.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`skill_development_title_${index}`] = el}
                                                  id={`skill_development_title_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter program title" defaultValue={skill?.title} onChange={(e) => setData(e.target.value, "skill_development", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.title?.message ? `Program Title ${validation?.skill_development[skill.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`skill_development_sponsored_agency_${index}`] = el}
                                                  id={`skill_development_sponsored_agency_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter Sponsoring Agency" defaultValue={skill?.sponsored_agency} onChange={(e) => setData(e.target.value, "skill_development", "sponsored_agency", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.sponsored_agency?.message ? `Sponsoring Agency ${validation?.skill_development[skill.id.toString()]?.sponsored_agency?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`skill_development_conducted_at_${index}`] = el}
                                                  id={`skill_development_conducted_at_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter Conducted At" defaultValue={skill?.conducted_at} onChange={(e) => setData(e.target.value, "skill_development", "conducted_at", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.conducted_at?.message ? `Conducted At ${validation?.skill_development[skill.id.toString()]?.conducted_at?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`skill_development_from_date_${index}`] = el}
                                                    id={`skill_development_from_date_${index}`} type="date" className="fieldinputreport mb-5" placeholder="Enter" key={index} defaultValue={skill?.from_date} onChange={(e) => setData(e.target.value, "skill_development", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.from_date?.message ? `From Date ${validation?.skill_development[skill.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`skill_development_to_date_${index}`] = el}
                                                    id={`skill_development_to_date_${index}`} type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={skill?.to_date} onChange={(e) => setData(e.target.value, "skill_development", "to_date", index)} min={moment(skill?.from_date).format("yyyy-MM-DD")} />
                                                </div>
                                                <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.to_date?.message ? `To Date ${validation?.skill_development[skill.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`skill_development_role_${index}`] = el}
                                                  id={`skill_development_role_${index}`} key={index} type="text" className="fieldinputreport" placeholder="Enter Role" defaultValue={skill?.role} onChange={(e) => setData(e.target.value, "skill_development", "role", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.role?.message ? `Role ${validation?.skill_development[skill.id.toString()]?.role?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`skill_development_no_of_hours_${index}`] = el}
                                                  id={`skill_development_no_of_hours_${index}`} key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={skill?.no_of_hours} onChange={(e) => setData(e.target.value, "skill_development", "no_of_hours", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.no_of_hours?.message ? `Hours Handled ${validation?.skill_development[skill.id.toString()]?.no_of_hours?.message}` : ""}</small>
                                            </td>
                                            {
                                              IsOldReportYear(report) ?
                                                <td>
                                                  <div>
                                                    <select
                                                      ref={el => inputRefB.current[`skill_development_level_${index}`] = el}
                                                      id={`skill_development_level_${index}`} key={index} className="fieldinputselectreport" defaultValue={skill?.level} onChange={(e) => setData(e.target.value, "skill_development", "level", index)}>
                                                      <option value="">Select Level</option>
                                                      <option value="national">National</option>
                                                      <option value="regional">Regional</option>
                                                      <option value="state">State</option>
                                                    </select>
                                                  </div>
                                                  <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.level?.message ? `Level ${validation?.skill_development[skill.id.toString()]?.level?.message}` : ""}</small>
                                                </td> : ''
                                            }
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`skill_development_amount_${index}`] = el}
                                                  id={`skill_development_amount_${index}`} key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Amount" defaultValue={skill?.amount} onChange={(e) => setData(e.target.value, "skill_development", "amount", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.skill_development[skill.id.toString()]?.amount?.message ? `Amount ${validation?.skill_development[skill.id.toString()]?.amount?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "skill_development", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {skill?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${skill?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.skill_development?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("skill_development", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.skill_development?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("skill_development", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        {IsOldReportYear(report) ?
                                          <td></td> : ''
                                        }
                                        <td>Total Grants Received</td>
                                        <td>{calculateSum(report?.skill_development, 'amount')}</td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                d. Development/offer of MOOCs / MMLPs as Coordinator / Co-coordinator or minimum 30 min video lectures / Educational video films :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.development_of_moocs.length}
                                    onChange={(yes) => {
                                      handle("development_of_moocs", "yes", {
                                        id: 0,
                                        title: "",
                                        ...(IsOldReportYear(report) ? { date_of_launch: "" } : { status: '' }),
                                        ...(IsOldReportYear(report) ? '' : { to_date: "" }),
                                        ...(IsOldReportYear(report) ? '' : { from_date: "" }),
                                        time_taken: "",
                                        platform: "",
                                        coordinator_or_co_coordinator: "",
                                        used_for: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.development_of_moocs.length}
                                    onChange={(no) => {
                                      handle("development_of_moocs", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.development_of_moocs.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">
                                          Title of the MOOC / MMLP / 30 min video <br />
                                          lectures / Educational video films
                                        </th>
                                        <th scope="col">{IsOldReportYear(report) ? 'Date of Launch' : 'Status'}</th>
                                        {!IsOldReportYear(report) ?
                                          <th scope="col">
                                            Duration
                                            <table className="table">
                                              <tr>
                                                <td className="w-50">From</td>
                                                <td className="w-50">To</td>
                                              </tr>
                                            </table>
                                          </th> : ''}
                                        <th scope="col">Time</th>
                                        <th scope="col">Platform</th>
                                        <th scope="col">Coordinator / Co-Coordinator</th>
                                        <th scope="col">Used for</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.development_of_moocs?.map((develop, index) => {
                                        return (
                                          <tr key={develop.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_moocs_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={develop?.title} onChange={(e) => setData(e.target.value, "development_of_moocs", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.title?.message ? `Title ${validation?.development_of_moocs[develop.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) ?
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`development_of_moocs_date_of_launch_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={develop?.date_of_launch} onChange={(e) => setData(e.target.value, "development_of_moocs", "date_of_launch", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.date_of_launch?.message ? `Launch Date ${validation?.development_of_moocs[develop.id.toString()]?.date_of_launch?.message}` : ""}</small>
                                              </td> :
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefB.current[`development_of_moocs_status_${index}`] = el}
                                                    key={index}
                                                    className="fieldinputselectreport"
                                                    defaultValue={develop?.status}
                                                    onChange={(e) => setData(e.target.value, "development_of_moocs", "status", index)}>
                                                    <option value="">Select Status</option>
                                                    <option value="development">Development</option>
                                                    <option value="run">Run</option>
                                                  </select>
                                                </div>
                                                <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.status?.message ? `Status ${validation?.development_of_moocs[develop.id.toString()]?.status?.message}` : ""}</small>
                                              </td>
                                            }
                                            {!IsOldReportYear(report) &&
                                              <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                                <div className="me-2 mb-5 pb-2">
                                                  <div>
                                                    <input
                                                      ref={el => inputRefB.current[`development_of_moocs_from_date_${index}`] = el}
                                                      type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={develop?.from_date} onChange={(e) => setData(e.target.value, "development_of_moocs", "from_date", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.from_date?.message ? `From Date ${validation?.development_of_moocs[develop.id.toString()]?.from_date?.message}` : ""}</small>
                                                </div>
                                                <div>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefB.current[`development_of_moocs_to_date_${index}`] = el}
                                                      type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={develop?.to_date} onChange={(e) => setData(e.target.value, "development_of_moocs", "to_date", index)} min={moment(develop?.from_date).format("yyyy-MM-DD")} />
                                                  </div>
                                                  <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.to_date?.message ? `To Date ${validation?.development_of_moocs[develop.id.toString()]?.to_date?.message}` : ""}</small>
                                                </div>
                                              </td>
                                            }
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`development_of_moocs_time_taken_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={develop?.time_taken} onChange={(e) => setData(e.target.value, "development_of_moocs", "time_taken", index)}>
                                                  <option value="">Select Time</option>
                                                  <option value="20 Hrs MOOC">20 Hrs MOOC</option>
                                                  <option value="40 Hrs MOOC">40 Hrs MOOC</option>
                                                  <option value="30 min video">30 min video</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.time_taken?.message ? `Time ${validation?.development_of_moocs[develop.id.toString()]?.time_taken?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`development_of_moocs_platform_${index}`] = el}
                                                  key={index}
                                                  className="fieldinputselectreport"
                                                  defaultValue={develop?.platform}
                                                  onChange={(e) => setData(e.target.value, "development_of_moocs", "platform", index)}>
                                                  <option value="">Select Platform</option>
                                                  <option value="swayam">Swayam</option>
                                                  <option value="nitttr">NITTT</option>
                                                  <option value="others">Others</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.platform?.message ? `Platform ${validation?.development_of_moocs[develop.id.toString()]?.platform?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`development_of_moocs_coordinator_or_co_coordinator_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={develop?.coordinator_or_co_coordinator} onChange={(e) => setData(e.target.value, "development_of_moocs", "coordinator_or_co_coordinator", index)}>
                                                  <option value="">Select Time</option>
                                                  <option value="coordinator">Coordinator</option>
                                                  <option value="co_coordinator">Co - Coordinator</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.coordinator_or_co_coordinator?.message ? `Type ${validation?.development_of_moocs[develop.id.toString()]?.coordinator_or_co_coordinator?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_moocs_used_for_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Used For" defaultValue={develop?.used_for} onChange={(e) => setData(e.target.value, "development_of_moocs", "used_for", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_moocs[develop.id.toString()]?.used_for?.message ? `Used For ${validation?.development_of_moocs[develop.id.toString()]?.used_for?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "development_of_moocs", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {develop?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${develop?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.development_of_moocs?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("development_of_moocs", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.development_of_moocs?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("development_of_moocs", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                e. Resource person in Training Programmes (Institute) :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.resource_person.length}
                                    onChange={(yes) => {
                                      handle("resource_person", "yes", {
                                        id: 0,
                                        fdp_no: "",
                                        mode: "",
                                        conducted_at: "",
                                        from_date: "",
                                        to_date: "",
                                        no_of_hours: "",
                                        ...(IsOldReportYear(report) ? { level: '' } : { course_type: '' }),
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.resource_person.length}
                                    onChange={(no) => {
                                      handle("resource_person", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.resource_person.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">{IsOldReportYear(report) ? 'FDP.No' : "Course Number"}</th>
                                        {!IsOldReportYear(report) ? <th scope="col">Course Type</th> : ""}
                                        <th scope="col">Mode</th>
                                        <th scope="col">Conducted at</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">No.of Hours Handled</th>
                                        {IsOldReportYear(report) ? <th scope="col">Level</th> : ""}
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.resource_person?.map((resource, index) => {
                                        return (
                                          <tr key={resource.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`resource_person_fdp_no_${index}`] = el}
                                                  key={index}
                                                  type="text"
                                                  className="fieldinputreport"
                                                  placeholder={IsOldReportYear(report) ? "Enter FDP No" : "Enter Course No"}
                                                  defaultValue={resource?.fdp_no}
                                                  onChange={(e) => setData(e.target.value, "resource_person", "fdp_no", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.fdp_no?.message ? `${IsOldReportYear(report) ? "FDP No" : "Course No"}  ${validation?.resource_person[resource.id.toString()]?.fdp_no?.message}` : ""}</small>
                                            </td>
                                            {!IsOldReportYear(report) &&
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`resource_person_course_type_${index}`] = el}
                                                    key={index} type="text" className="fieldinputreport" placeholder="Enter Course type" defaultValue={resource?.course_type} onChange={(e) => setData(e.target.value, "resource_person", "course_type", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.course_type?.message ? `Course Type ${validation?.resource_person[resource.id.toString()]?.course_type?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`resource_person_mode_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={resource?.mode} onChange={(e) => setData(e.target.value, "resource_person", "mode", index)}>
                                                  <option value="">Select Mode</option>
                                                  <option value="contact">Contact</option>
                                                  <option value="online">Online</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.mode?.message ? `Mode ${validation?.resource_person[resource.id.toString()]?.mode?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`resource_person_conducted_at_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Conducted At" defaultValue={resource?.conducted_at} onChange={(e) => setData(e.target.value, "resource_person", "conducted_at", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.conducted_at?.message ? `Conducted At ${validation?.resource_person[resource.id.toString()]?.conducted_at?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input ref={el => inputRefB.current[`resource_person_from_date_${index}`] = el} type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={resource?.from_date} onChange={(e) => setData(e.target.value, "resource_person", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.from_date?.message ? `From Date ${validation?.resource_person[resource.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`resource_person_to_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={resource?.to_date} onChange={(e) => setData(e.target.value, "resource_person", "to_date", index)} min={moment(resource?.from_date).format("yyyy-MM-DD")} />
                                                </div>
                                                <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.to_date?.message ? `To Date ${validation?.resource_person[resource.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`resource_person_no_of_hours_${index}`] = el}
                                                  key={index}
                                                  onKeyDown={(e) => Restrict(e)}
                                                  type="number" className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={resource?.no_of_hours} onChange={(e) => setData(e.target.value, "resource_person", "no_of_hours", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.no_of_hours?.message ? `Hours Handled ${validation?.resource_person[resource.id.toString()]?.no_of_hours?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) &&
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefB.current[`resource_person_level_${index}`] = el}
                                                    key={index} className="fieldinputselectreport" defaultValue={resource?.level} onChange={(e) => setData(e.target.value, "resource_person", "level", index)}>
                                                    <option value="">Select Level</option>
                                                    <option value="national">National</option>
                                                    <option value="regional">Regional</option>
                                                    <option value="state">State</option>
                                                  </select>
                                                </div>
                                                <small className="validationerror">{validation?.resource_person[resource.id.toString()]?.level?.message ? `Level ${validation?.resource_person[resource.id.toString()]?.level?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              {report?.resource_person?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("resource_person", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.resource_person?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("resource_person", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        {!IsOldReportYear(report) &&
                                          <td></td>}
                                        <td></td>
                                        <td>Total Number of hours handled</td>
                                        <td>{calculateSum(report?.resource_person, 'no_of_hours')}</td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                f. Development of Training / Laboratory Manuals:
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.development_of_training_manual.length}
                                    onChange={(yes) => {
                                      handle("development_of_training_manual", "yes", {
                                        id: 0,
                                        author_name: "",
                                        title: "",
                                        type_of_publications: "",
                                        publisher_country: "",
                                        publisher_year: "",
                                        total_pages: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.development_of_training_manual.length}
                                    onChange={(no) => {
                                      handle("development_of_training_manual", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.development_of_training_manual.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Author (s) Name in order as appeared</th>
                                        <th scope="col">Title</th>
                                        <th scope="col">Type of publications</th>
                                        <th scope="col">Publisher Country</th>
                                        <th scope="col">Publisher Year</th>
                                        <th scope="col">Total Pages</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.development_of_training_manual?.map((development, index) => {
                                        return (
                                          <tr key={development.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_training_manual_author_name_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Author Name" defaultValue={development?.author_name} onChange={(e) => setData(e.target.value, "development_of_training_manual", "author_name", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_training_manual[development.id.toString()]?.author_name?.message ? `Author Name ${validation?.development_of_training_manual[development.id.toString()]?.author_name?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_training_manual_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={development?.title} onChange={(e) => setData(e.target.value, "development_of_training_manual", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_training_manual[development.id.toString()]?.title?.message ? `Title ${validation?.development_of_training_manual[development.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_training_manual_type_of_publications_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Publication Type" defaultValue={development?.type_of_publications} onChange={(e) => setData(e.target.value, "development_of_training_manual", "type_of_publications", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_training_manual[development.id.toString()]?.type_of_publications?.message ? `Publication Type ${validation?.development_of_training_manual[development.id.toString()]?.type_of_publications?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_training_manual_publisher_country_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Publisher Country" defaultValue={development?.publisher_country} onChange={(e) => setData(e.target.value, "development_of_training_manual", "publisher_country", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_training_manual[development.id.toString()]?.publisher_country?.message ? `Publisher Country ${validation?.development_of_training_manual[development.id.toString()]?.publisher_country?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_training_manual_publisher_year_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Publisher Year" maxLength={4} defaultValue={development?.publisher_year} onChange={(e) => setData(e.target.value, "development_of_training_manual", "publisher_year", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_training_manual[development.id.toString()]?.publisher_year?.message ? `Publisher Year ${validation?.development_of_training_manual[development.id.toString()]?.publisher_year?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`development_of_training_manual_total_pages_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Total Pages" defaultValue={development?.total_pages} onChange={(e) => setData(e.target.value, "development_of_training_manual", "total_pages", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.development_of_training_manual[development.id.toString()]?.total_pages?.message ? `Total Pages ${validation?.development_of_training_manual[development.id.toString()]?.total_pages?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input
                                                key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "development_of_training_manual", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {development?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${development?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.development_of_training_manual?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("development_of_training_manual", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.development_of_training_manual?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("development_of_training_manual", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                g. Courses handled for PG / Ph.D. Programme :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.courses_handled_for_pg_phd.length}
                                    onChange={(yes) => {
                                      handle("courses_handled_for_pg_phd", "yes", {
                                        id: 0,
                                        course_number_and_title: "",
                                        pg_or_phd: "",
                                        theory_or_laboratory: "",
                                        credit: "",
                                        ...(IsOldReportYear(report) && { university_or_institute: "" }),
                                        ...(!IsOldReportYear(report) && { from_date: "" }),
                                        ...(!IsOldReportYear(report) && { to_date: "" }),
                                        individual_or_shared: "",
                                        ...(IsOldReportYear(report) && { no_of_hours: "" }),
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.courses_handled_for_pg_phd.length}
                                    onChange={(no) => {
                                      handle("courses_handled_for_pg_phd", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.courses_handled_for_pg_phd.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Course Number and Title</th>
                                        <th scope="col">Degree</th>
                                        <th scope="col">Type of Subject</th>
                                        <th scope="col">Credit</th>
                                        {!IsOldReportYear(report) &&
                                          <th scope="col">
                                            Duration
                                            <table className="table">
                                              <tr>
                                                <td className="w-50">From</td>
                                                <td className="w-50">To</td>
                                              </tr>
                                            </table>
                                          </th>
                                        }
                                        {IsOldReportYear(report) &&
                                          <th scope="col">Type of College</th>
                                        }
                                        <th scope="col">Type</th>
                                        {IsOldReportYear(report) &&
                                          <th scope="col">No.of Hours Handled</th>
                                        }
                                        <th scope="col">Attachemnt</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.courses_handled_for_pg_phd?.map((courses, index) => {
                                        return (
                                          <tr key={courses.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`courses_handled_for_pg_phd_course_number_and_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Course Number & Title" defaultValue={courses?.course_number_and_title} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "course_number_and_title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.course_number_and_title?.message ? `Course Name ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.course_number_and_title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`courses_handled_for_pg_phd_pg_or_phd_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={courses?.pg_or_phd} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "pg_or_phd", index)}>
                                                  <option value="">Select Degree</option>
                                                  <option value="pg">PG</option>
                                                  <option value="phd">Ph.D</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.pg_or_phd?.message ? `Degree ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.pg_or_phd?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`courses_handled_for_pg_phd_theory_or_laboratory_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={courses?.theory_or_laboratory} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "theory_or_laboratory", index)}>
                                                  <option value="">Select Subject</option>
                                                  <option value="theory">Theory</option>
                                                  <option value="laboratory">Laboratory</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.theory_or_laboratory?.message ? `Subject ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.theory_or_laboratory?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`courses_handled_for_pg_phd_credit_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={courses?.credit} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "credit", index)}>
                                                  <option value="">Select Credit</option>
                                                  <option value="1">1</option>
                                                  <option value="2">2</option>
                                                  <option value="3">3</option>
                                                  <option value="4">4</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.credit?.message ? `Credit ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.credit?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) ?
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefB.current[`courses_handled_for_pg_phd_university_or_institute_${index}`] = el}
                                                    key={index} className="fieldinputselectreport" defaultValue={courses?.university_or_institute} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "university_or_institute", index)}>
                                                    <option value="">Select College Type</option>
                                                    <option value="university">University</option>
                                                    <option value="institute">Institute</option>
                                                  </select>
                                                </div>
                                                <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.university_or_institute?.message ? `College Type ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.university_or_institute?.message}` : ""}</small>
                                              </td> :
                                              <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                                <div className="me-2 mb-5 pb-2">
                                                  <div>
                                                    <input
                                                      ref={el => inputRefB.current[`courses_handled_for_pg_phd_from_date_${index}`] = el}
                                                      type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={courses?.from_date} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "from_date", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.from_date?.message ? `From Date ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.from_date?.message}` : ""}</small>
                                                </div>
                                                <div>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefB.current[`courses_handled_for_pg_phd_to_date_${index}`] = el}
                                                      type="date"
                                                      className="fieldinputreport"
                                                      placeholder="Enter"
                                                      key={index}
                                                      defaultValue={courses?.to_date}
                                                      onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "to_date", index)}
                                                      min={moment(courses?.from_date).format("yyyy-MM-DD")}
                                                    />
                                                  </div>
                                                  <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.to_date?.message ? `TO Date ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.to_date?.message}` : ""}</small>
                                                </div>
                                              </td>
                                            }
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`courses_handled_for_pg_phd_individual_or_shared_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={courses?.individual_or_shared} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "individual_or_shared", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="individual">Individual</option>
                                                  <option value="shared">Shared</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.individual_or_shared?.message ? `Type ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.individual_or_shared?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) &&
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`courses_handled_for_pg_phd_no_of_hours_${index}`] = el}
                                                    key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={courses?.no_of_hours} onChange={(e) => setData(e.target.value, "courses_handled_for_pg_phd", "no_of_hours", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.courses_handled_for_pg_phd[courses.id.toString()]?.no_of_hours?.message ? `Hours Handled ${validation?.courses_handled_for_pg_phd[courses.id.toString()]?.no_of_hours?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              <input
                                                key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "courses_handled_for_pg_phd", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {courses?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${courses?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.courses_handled_for_pg_phd?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("courses_handled_for_pg_phd", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.courses_handled_for_pg_phd?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("courses_handled_for_pg_phd", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                h. New Course(s) developed and offered :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.new_courses_developed_offered.length}
                                    onChange={(yes) => {
                                      handle("new_courses_developed_offered", "yes", {
                                        id: 0,
                                        course_number_and_title: "",
                                        pg_phd_or_fdp_level: "",
                                        theory_or_laboratory: "",
                                        credit: "",
                                        ...(IsOldReportYear(report) && { university_or_institute: "" }),
                                        individual_or_shared: "",
                                        ...(IsOldReportYear(report) ? { no_of_times: "" } : { first_time_offered: "" }),
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.new_courses_developed_offered.length}
                                    onChange={(no) => {
                                      handle("new_courses_developed_offered", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.new_courses_developed_offered.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Course Number and title</th>
                                        <th scope="col">Degree</th>
                                        <th scope="col">Type of Subject</th>
                                        <th scope="col">Credit</th>
                                        {IsOldReportYear(report) &&
                                          <th scope="col">Type of College</th>
                                        }
                                        <th scope="col">Type</th>
                                        <th scope="col">{IsOldReportYear(report) ? 'No.of times Offered' : 'First Time Offered'}</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.new_courses_developed_offered?.map((newcourses, index) => {
                                        return (
                                          <tr key={newcourses.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`new_courses_developed_offered_course_number_and_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Course Number & Title" defaultValue={newcourses?.course_number_and_title} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "course_number_and_title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.course_number_and_title?.message ? `Course Name ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.course_number_and_title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`new_courses_developed_offered_pg_phd_or_fdp_level_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={newcourses?.pg_phd_or_fdp_level} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "pg_phd_or_fdp_level", index)}>
                                                  <option value="">Select Degree</option>
                                                  <option value="pg">PG</option>
                                                  <option value="phd">Ph.D.Level</option>
                                                  <option value="fdp">FDP Training</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.pg_phd_or_fdp_level?.message ? `Degree ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.pg_phd_or_fdp_level?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`new_courses_developed_offered_theory_or_laboratory_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={newcourses?.theory_or_laboratory} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "theory_or_laboratory", index)}>
                                                  <option value="">Select Subject</option>
                                                  <option value="theory">Theory</option>
                                                  <option value="laboratory">Laboratory</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.theory_or_laboratory?.message ? `Subject ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.theory_or_laboratory?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`new_courses_developed_offered_credit_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={newcourses?.credit} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "credit", index)}>
                                                  <option value="">Select Credit</option>
                                                  <option value="1">1</option>
                                                  <option value="2">2</option>
                                                  <option value="3">3</option>
                                                  <option value="4">4</option>
                                                </select>
                                              </div>

                                              <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.credit?.message ? `Credit ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.credit?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) &&
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefB.current[`new_courses_developed_offered_university_or_institute_${index}`] = el}
                                                    key={index} className="fieldinputselectreport" defaultValue={newcourses?.university_or_institute} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "university_or_institute", index)}>
                                                    <option value="">Select College Type</option>
                                                    <option value="university">University</option>
                                                    <option value="institute">Institute</option>
                                                  </select>
                                                </div>

                                                <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.university_or_institute?.message ? `College Type ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.university_or_institute?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefB.current[`new_courses_developed_offered_individual_or_shared_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={newcourses?.individual_or_shared} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "individual_or_shared", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="individual">Individual</option>
                                                  <option value="shared">Shared</option>
                                                </select>
                                              </div>

                                              <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.individual_or_shared?.message ? `Type ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.individual_or_shared?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) ?
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`new_courses_developed_offered_no_of_times_${index}`] = el}
                                                    key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={newcourses?.no_of_times} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "no_of_times", index)} />
                                                </div>

                                                <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.no_of_times?.message ? `Time Handled ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.no_of_times?.message}` : ""}</small>
                                              </td> :
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefB.current[`new_courses_developed_offered_first_time_offered_${index}`] = el}
                                                    key={index} type="text" className="fieldinputreport" placeholder="Enter" defaultValue={newcourses?.first_time_offered} onChange={(e) => setData(e.target.value, "new_courses_developed_offered", "first_time_offered", index)} />
                                                </div>

                                                <small className="validationerror">{validation?.new_courses_developed_offered[newcourses.id.toString()]?.first_time_offered?.message ? `Data ${validation?.new_courses_developed_offered[newcourses.id.toString()]?.first_time_offered?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              {report?.new_courses_developed_offered?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("new_courses_developed_offered", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.new_courses_developed_offered?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("new_courses_developed_offered", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                i. Curriculum Developed / Revised :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.curriculum_developed_or_revised.length}
                                    onChange={(yes) => {
                                      handle("curriculum_developed_or_revised", "yes", {
                                        id: 0,
                                        client: "",
                                        ...(IsOldReportYear(report) && {
                                          curriculum_developed: {
                                            no_of_programs: "",
                                            no_of_courses: "",
                                          },
                                          curriculum_revised: {
                                            no_of_programs: "",
                                            no_of_courses: "",
                                          }
                                        }),
                                        ...(!IsOldReportYear(report) && { developed_or_revised: "" }),
                                        ...(!IsOldReportYear(report) && { no_of_courses: "" }),
                                        amount: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.curriculum_developed_or_revised.length}
                                    onChange={(no) => {
                                      handle("curriculum_developed_or_revised", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.curriculum_developed_or_revised.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Role Type</th>
                                        {IsOldReportYear(report) ?
                                          <>
                                            <th scope="col">
                                              Curriculum Developed
                                              <table className="table">
                                                <tr>
                                                  <td>No.of Programs</td>
                                                  <td>No.of Courses</td>
                                                </tr>
                                              </table>
                                            </th>
                                            <th scope="col">
                                              Curriculum Revised
                                              <table className="table">
                                                <tr>
                                                  <td>No.of Programs</td>
                                                  <td>No.of Courses</td>
                                                </tr>
                                              </table>
                                            </th>
                                          </> :
                                          <>
                                            <th scope="col">Curriculam</th>
                                            <th scope="col">No. of Courses</th>
                                          </>
                                        }

                                        <th scope="col">Amount (Rs. in Lakhs)</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.curriculum_developed_or_revised?.map((curriculum, index) => {
                                        return (
                                          <tr key={curriculum.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`curriculum_developed_or_revised_client_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={curriculum?.client} onChange={(e) => setData(e.target.value, "curriculum_developed_or_revised", "client", index)} placeholder="Enter Client Name" />
                                              </div>
                                              <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.client?.message ? `Time Handled ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.client?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) ?
                                              <>
                                                <td>
                                                  <table className="table">
                                                    <tr>
                                                      <td>
                                                        <input
                                                          ref={el => inputRefB.current[`curriculum_developed_or_revised_curriculum_developed_no_of_programs_${index}`] = el}
                                                          type="text" className="fieldinputreport" placeholder="Enter No.of Programs" key={index} defaultValue={curriculum?.curriculum_developed?.no_of_programs} onChange={(e) => setData1(e.target.value, "curriculum_developed_or_revised", "curriculum_developed", "no_of_programs", index)} />
                                                        <br />
                                                        <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_developed?.no_of_programs?.message ? `Field ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_developed?.no_of_programs?.message}` : ""}</small>
                                                      </td>
                                                      <td>
                                                        <input
                                                          ref={el => inputRefB.current[`curriculum_developed_or_revised_curriculum_developed_no_of_courses_${index}`] = el}
                                                          type="text" className="fieldinputreport" placeholder="Enter No.of Courses" key={index} defaultValue={curriculum?.curriculum_developed?.no_of_courses} onChange={(e) => setData1(e.target.value, "curriculum_developed_or_revised", "curriculum_developed", "no_of_courses", index)} /><br />
                                                        <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_developed?.no_of_courses?.message ? `Field ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_developed?.no_of_courses?.message}` : ""}</small>
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </td>
                                                <td>
                                                  <table className="table">
                                                    <tr>
                                                      <td>
                                                        <input
                                                          ref={el => inputRefB.current[`curriculum_developed_or_revised_curriculum_revised_no_of_programs_${index}`] = el}
                                                          type="text" className="fieldinputreport" placeholder="Enter No.of Programs" key={index} defaultValue={curriculum?.curriculum_revised?.no_of_programs} onChange={(e) => setData1(e.target.value, "curriculum_developed_or_revised", "curriculum_revised", "no_of_programs", index)} /><br />
                                                        <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_revised?.no_of_programs?.message ? `Field ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_revised?.no_of_programs?.message}` : ""}</small>
                                                      </td>
                                                      <td>
                                                        <input
                                                          ref={el => inputRefB.current[`curriculum_developed_or_revised_curriculum_revised_no_of_courses_${index}`] = el}
                                                          type="text" className="fieldinputreport" placeholder="Enter No.of Courses" key={index} defaultValue={curriculum?.curriculum_revised?.no_of_courses} onChange={(e) => setData1(e.target.value, "curriculum_developed_or_revised", "curriculum_revised", "no_of_courses", index)} /><br />
                                                        <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_revised?.no_of_courses?.message ? `Field ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.curriculum_revised?.no_of_courses?.message}` : ""}</small>
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </td>
                                              </>
                                              :
                                              <>
                                                <td>
                                                  <div>
                                                    <select
                                                      ref={el => inputRefB.current[`curriculum_developed_or_revised_developed_or_revised_${index}`] = el}
                                                      key={index} className="fieldinputselectreport" defaultValue={curriculum?.developed_or_revised} onChange={(e) => setData(e.target.value, "curriculum_developed_or_revised", "developed_or_revised", index)}>
                                                      <option value="">Select Curriculam</option>
                                                      <option value="developed">Developed</option>
                                                      <option value="revised">Revised</option>
                                                    </select>
                                                  </div>
                                                  <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.developed_or_revised?.message ? `Type ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.developed_or_revised?.message}` : ""}</small>
                                                </td>
                                                <td>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefB.current[`curriculum_developed_or_revised_no_of_courses_${index}`] = el}
                                                      key={index} type="text" className="fieldinputreport" placeholder="Enter No of Courses" defaultValue={curriculum?.no_of_courses} onChange={(e) => setData(e.target.value, "curriculum_developed_or_revised", "no_of_courses", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.no_of_courses?.message ? `No Of Courses ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.no_of_courses?.message}` : ""}</small>
                                                </td>
                                              </>
                                            }
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefB.current[`curriculum_developed_or_revised_amount_${index}`] = el}
                                                  key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={curriculum?.amount} onChange={(e) => setData(e.target.value, "curriculum_developed_or_revised", "amount", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.amount?.message ? `Amount ${validation?.curriculum_developed_or_revised[curriculum.id.toString()]?.amount?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              {report?.curriculum_developed_or_revised?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("curriculum_developed_or_revised", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.curriculum_developed_or_revised?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("curriculum_developed_or_revised", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {active === 2 && (
                        <>
                          <h5 className="centertext my-5">RESEARCH CONTRIBUTIONS</h5>
                          <div>
                            <div>
                              <h6 className="reporttitle">
                                a. Ph.D. research scholars guided :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.phd_research_guidances.length}
                                    onChange={(yes) => {
                                      handle("phd_research_guidances", "yes", {
                                        id: 0,
                                        name_of_the_student: "",
                                        title: "",
                                        affiliating_university: "",
                                        year_of_completion: "",
                                        supervisor_or_joint_supervisor: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.phd_research_guidances.length}
                                    onChange={(no) => {
                                      handle("phd_research_guidances", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.phd_research_guidances.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Name of Ph.D. Students</th>
                                        <th scope="col">Title of thesis</th>
                                        <th scope="col">NITTTR / Affiliating University</th>
                                        <th scope="col">Year of Completion</th>
                                        <th scope="col">Staff</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.phd_research_guidances?.map((phd, index) => {
                                        return (
                                          <tr key={phd.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`phd_research_guidances_name_of_the_student_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Name of Student" defaultValue={phd?.name_of_the_student} onChange={(e) => setData(e.target.value, "phd_research_guidances", "name_of_the_student", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.phd_research_guidances[phd.id.toString()]?.name_of_the_student?.message ? `Amount ${validation?.phd_research_guidances[phd.id.toString()]?.name_of_the_student?.message}` : ""}</small>
                                              <small className="validationerror">{validation?.name_of_the_student?.message ? `Name of Student ${validation?.name_of_the_student?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`phd_research_guidances_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title of Thesis" defaultValue={phd?.title} onChange={(e) => setData(e.target.value, "phd_research_guidances", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.phd_research_guidances[phd.id.toString()]?.title?.message ? `Title of Thesis ${validation?.phd_research_guidances[phd.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`phd_research_guidances_affiliating_university_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter NITTTR / Affiliating University" defaultValue={phd?.affiliating_university} onChange={(e) => setData(e.target.value, "phd_research_guidances", "affiliating_university", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.phd_research_guidances[phd.id.toString()]?.affiliating_university?.message ? `NITTTR / Affiliating University ${validation?.phd_research_guidances[phd.id.toString()]?.affiliating_university?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`phd_research_guidances_year_of_completion_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Year of Completion" maxLength={4} defaultValue={phd?.year_of_completion} onChange={(e) => setData(e.target.value, "phd_research_guidances", "year_of_completion", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.phd_research_guidances[phd.id.toString()]?.year_of_completion?.message ? `Year of Completion ${validation?.phd_research_guidances[phd.id.toString()]?.year_of_completion?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`phd_research_guidances_supervisor_or_joint_supervisor_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={phd?.supervisor_or_joint_supervisor} onChange={(e) => setData(e.target.value, "phd_research_guidances", "supervisor_or_joint_supervisor", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="supervisor">Supervisor</option>
                                                  <option value="joint_supervisor">Joint Supervisor</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.phd_research_guidances[phd.id.toString()]?.supervisor_or_joint_supervisor?.message ? `Type ${validation?.phd_research_guidances[phd.id.toString()]?.supervisor_or_joint_supervisor?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input
                                                key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "phd_research_guidances", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {phd?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${phd?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.phd_research_guidances?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("phd_research_guidances", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.phd_research_guidances?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("phd_research_guidances", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                b. Post Graduate thesis guided :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.post_graduate_thesis_guidances.length}
                                    onChange={(yes) => {
                                      handle("post_graduate_thesis_guidances", "yes", {
                                        id: 0,
                                        name_of_the_student: "",
                                        title: "",
                                        affiliating_university: "",
                                        year_of_completion: "",
                                        supervisor_or_joint_supervisor: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.post_graduate_thesis_guidances.length}
                                    onChange={(no) => {
                                      handle("post_graduate_thesis_guidances", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.post_graduate_thesis_guidances.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Name of P.G Students</th>
                                        <th scope="col">Title of thesis</th>
                                        <th scope="col">NITTTR / Affiliating University</th>
                                        <th scope="col">Year of Completion</th>
                                        <th scope="col">Staff</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.post_graduate_thesis_guidances?.map((post, index) => {
                                        return (
                                          <tr key={post.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`post_graduate_thesis_guidances_name_of_the_student_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Name of Student" defaultValue={post?.name_of_the_student} onChange={(e) => setData(e.target.value, "post_graduate_thesis_guidances", "name_of_the_student", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.post_graduate_thesis_guidances[post.id.toString()]?.name_of_the_student?.message ? `Name of Student ${validation?.post_graduate_thesis_guidances[post.id.toString()]?.name_of_the_student?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`post_graduate_thesis_guidances_title_${index}`] = el} key={index} type="text" className="fieldinputreport" placeholder="Enter Title of Thesis" defaultValue={post?.title} onChange={(e) => setData(e.target.value, "post_graduate_thesis_guidances", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.post_graduate_thesis_guidances[post.id.toString()]?.title?.message ? `Title of Thesis ${validation?.post_graduate_thesis_guidances[post.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`post_graduate_thesis_guidances_affiliating_university_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter NITTTR / Affiliating University" defaultValue={post?.affiliating_university} onChange={(e) => setData(e.target.value, "post_graduate_thesis_guidances", "affiliating_university", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.post_graduate_thesis_guidances[post.id.toString()]?.affiliating_university?.message ? `NITTTR / Affiliating University ${validation?.post_graduate_thesis_guidances[post.id.toString()]?.affiliating_university?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`post_graduate_thesis_guidances_year_of_completion_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Year of Completion" maxLength={4} defaultValue={post?.year_of_completion} onChange={(e) => setData(e.target.value, "post_graduate_thesis_guidances", "year_of_completion", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.post_graduate_thesis_guidances[post.id.toString()]?.year_of_completion?.message ? `Year of Completion ${validation?.post_graduate_thesis_guidances[post.id.toString()]?.year_of_completion?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`post_graduate_thesis_guidances_supervisor_or_joint_supervisor_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={post?.supervisor_or_joint_supervisor} onChange={(e) => setData(e.target.value, "post_graduate_thesis_guidances", "supervisor_or_joint_supervisor", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="supervisor">Supervisor</option>
                                                  <option value="joint_supervisor">Joint Supervisor</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.post_graduate_thesis_guidances[post.id.toString()]?.supervisor_or_joint_supervisor?.message ? `Type ${validation?.post_graduate_thesis_guidances[post.id.toString()]?.supervisor_or_joint_supervisor?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input
                                                key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "post_graduate_thesis_guidances", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {post?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${post?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.post_graduate_thesis_guidances?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("post_graduate_thesis_guidances", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.post_graduate_thesis_guidances?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("post_graduate_thesis_guidances", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                c. Sponsored research projects carried out :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.sponsored_research_projects.length}
                                    onChange={(yes) => {
                                      handle("sponsored_research_projects", "yes", {
                                        id: 0,
                                        title: "",
                                        sponsored_agency: "",
                                        from_date: "",
                                        to_date: "",
                                        ...(IsOldReportYear(report) && { duration: "" }),
                                        ...(IsOldReportYear(report) && { research_consultancy: "" }),
                                        pi_or_co_pi: "",
                                        ongoing_or_submitted: "",
                                        amount: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.sponsored_research_projects.length}
                                    onChange={(no) => {
                                      handle("sponsored_research_projects", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.sponsored_research_projects.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Project Title</th>
                                        <th scope="col">Sponsored Agency</th>
                                        <th scope="col">
                                          Period
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        {IsOldReportYear(report) &&
                                          <>
                                            <th scope="col">Duration (YY-MM)</th>
                                            <th scope="col">Research</th>
                                          </>
                                        }
                                        <th scope="col">PI or Co-PI</th>
                                        <th scope="col">Ongoing / Submitted</th>
                                        <th scope="col">Amount of Grant(Rs. in Lakhs)</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.sponsored_research_projects?.map((sponsoredre, index) => {
                                        return (
                                          <tr key={sponsoredre.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`sponsored_research_projects_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter project Title" defaultValue={sponsoredre?.title} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.title?.message ? `Project Title ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`sponsored_research_projects_sponsored_agency_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Sponsored Agency" defaultValue={sponsoredre?.sponsored_agency} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "sponsored_agency", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.sponsored_agency?.message ? `Sponsored Agency ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.sponsored_agency?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefC.current[`sponsored_research_projects_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={sponsoredre?.from_date} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.from_date?.message ? `From Date ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefC.current[`sponsored_research_projects_to_date_${index}`] = el}
                                                    type="date"
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={sponsoredre?.to_date}
                                                    onChange={(e) => setData(e.target.value, "sponsored_research_projects", "to_date", index)}
                                                    min={moment(sponsoredre?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.to_date?.message ? `TO Date ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            {IsOldReportYear(report) &&
                                              <>
                                                <td>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefC.current[`sponsored_research_projects_duration_${index}`] = el}
                                                      key={index} type="text" className="fieldinputreport" placeholder="Enter Duration (YY-MM)" defaultValue={sponsoredre?.duration} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "duration", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.duration?.message ? `Duration ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.duration?.message}` : ""}</small>
                                                </td>
                                                <td>
                                                  <div>
                                                    <select
                                                      ref={el => inputRefC.current[`sponsored_research_projects_research_consultancy_${index}`] = el}
                                                      key={index} className="fieldinputselectreport" defaultValue={sponsoredre?.research_consultancy} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "research_consultancy", index)}>
                                                      <option value="">Select Type</option>
                                                      <option value="research">Research</option>
                                                    </select>
                                                  </div>
                                                  <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.research_consultancy?.message ? `Type ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.research_consultancy?.message}` : ""}</small>
                                                </td>
                                              </>
                                            }
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`sponsored_research_projects_pi_or_co_pi_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={sponsoredre?.pi_or_co_pi} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "pi_or_co_pi", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="pi">PI</option>
                                                  <option value="co_pi">Co-PI</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.pi_or_co_pi?.message ? `Type ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.pi_or_co_pi?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`sponsored_research_projects_ongoing_or_submitted_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={sponsoredre?.ongoing_or_submitted} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "ongoing_or_submitted", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="ongoing">Ongoing</option>
                                                  <option value="submitted">Submitted</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.ongoing_or_submitted?.message ? `Type ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.ongoing_or_submitted?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`sponsored_research_projects_amount_${index}`] = el}
                                                  key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Amount" defaultValue={sponsoredre?.amount} onChange={(e) => setData(e.target.value, "sponsored_research_projects", "amount", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.sponsored_research_projects[sponsoredre.id.toString()]?.amount?.message ? `Amount ${validation?.sponsored_research_projects[sponsoredre.id.toString()]?.amount?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "sponsored_research_projects", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {sponsoredre?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${sponsoredre?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.sponsored_research_projects?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("sponsored_research_projects", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.sponsored_research_projects?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("sponsored_research_projects", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        {IsOldReportYear(report) && <td></td>}
                                        {IsOldReportYear(report) && <td></td>}
                                        <td></td>
                                        <td>Total Amount of Grant</td>
                                        <td>{calculateSum(report?.sponsored_research_projects, 'amount')}</td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                d. Consultancy works carried out based On the requirements of the clientele system :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.consultancy_works_carried_out.length}
                                    onChange={(yes) => {
                                      handle("consultancy_works_carried_out", "yes", {
                                        id: 0,
                                        title: "",
                                        sponsored_agency: "",
                                        from_date: "",
                                        to_date: "",
                                        ...(IsOldReportYear(report) && { duration: "" }),
                                        ...(IsOldReportYear(report) && { research_consultancy: "" }),
                                        pi_or_co_pi: "",
                                        amount: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.consultancy_works_carried_out.length}
                                    onChange={(no) => {
                                      handle("consultancy_works_carried_out", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.consultancy_works_carried_out.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Project Title/Cources Conducted</th>
                                        <th scope="col">Sponsored Agency</th>
                                        <th scope="col">
                                          Period
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        {IsOldReportYear(report) &&
                                          <>
                                            <th scope="col">Duration (YY-MM)</th>
                                            <th scope="col">Consultancy</th>
                                          </>
                                        }
                                        <th scope="col">PI or Co-PI</th>
                                        <th scope="col">Amount of Grant(Rs. in Lakhs)</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.consultancy_works_carried_out?.map((consult, index) => {
                                        return (
                                          <tr key={consult.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`consultancy_works_carried_out_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter project Title" defaultValue={consult?.title} onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.title?.message ? `Project Title ${validation?.consultancy_works_carried_out[consult.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`consultancy_works_carried_out_sponsored_agency_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Sponsored Agency" defaultValue={consult?.sponsored_agency} onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "sponsored_agency", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.sponsored_agency?.message ? `Sponsored Agency ${validation?.consultancy_works_carried_out[consult.id.toString()]?.sponsored_agency?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefC.current[`consultancy_works_carried_out_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={consult?.from_date} onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.from_date?.message ? `From Date ${validation?.consultancy_works_carried_out[consult.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    type="date"
                                                    ref={el => inputRefC.current[`consultancy_works_carried_out_to_date_${index}`] = el}
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={consult?.to_date}
                                                    onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "to_date", index)}
                                                    min={moment(consult?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.to_date?.message ? `To Date ${validation?.consultancy_works_carried_out[consult.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            {
                                              IsOldReportYear(report) &&
                                              <>
                                                <td>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefC.current[`consultancy_works_carried_out_duration_${index}`] = el}
                                                      key={index} type="text" className="fieldinputreport" maxLength={5} placeholder="Enter Duration (YY-MM)" defaultValue={consult?.duration} onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "duration", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.duration?.message ? `Duration ${validation?.consultancy_works_carried_out[consult.id.toString()]?.duration?.message}` : ""}</small>
                                                </td>
                                                <td>
                                                  <div>
                                                    <select
                                                      ref={el => inputRefC.current[`consultancy_works_carried_out_research_consultancy_${index}`] = el}
                                                      key={index} className="fieldinputselectreport" defaultValue={consult?.research_consultancy} onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "research_consultancy", index)}>
                                                      <option value="">Select Type</option>
                                                      <option value="consultancy">Consultancy</option>
                                                    </select>
                                                  </div>
                                                  <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.research_consultancy?.message ? `Type ${validation?.consultancy_works_carried_out[consult.id.toString()]?.research_consultancy?.message}` : ""}</small>
                                                </td>
                                              </>
                                            }

                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`consultancy_works_carried_out_pi_or_co_pi_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={consult?.pi_or_co_pi} onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "pi_or_co_pi", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="pi">PI</option>
                                                  <option value="co_pi">Co-PI</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.pi_or_co_pi?.message ? `Type ${validation?.consultancy_works_carried_out[consult.id.toString()]?.pi_or_co_pi?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`consultancy_works_carried_out_amount_${index}`] = el}
                                                  key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Amount" defaultValue={consult?.amount} onChange={(e) => setData(e.target.value, "consultancy_works_carried_out", "amount", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.consultancy_works_carried_out[consult.id.toString()]?.amount?.message ? `Amount ${validation?.consultancy_works_carried_out[consult.id.toString()]?.amount?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "consultancy_works_carried_out", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {consult?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${consult?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.consultancy_works_carried_out?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("consultancy_works_carried_out", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.consultancy_works_carried_out?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("consultancy_works_carried_out", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        {IsOldReportYear(report) && <td></td>}
                                        {IsOldReportYear(report) && <td></td>}
                                        <td></td>
                                        <td>Total amount of grant</td>
                                        <td>{calculateSum(report?.consultancy_works_carried_out, 'amount')}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                e. Research Publications in referred journals only :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.research_publications.length}
                                    onChange={(yes) => {
                                      handle("research_publications", "yes", {
                                        id: 0,
                                        author_name: "",
                                        title: "",
                                        name_of_journal: "",
                                        volume_no: "",
                                        volume_issue: "",
                                        year: "",
                                        sci_scopus_ugc: "",
                                        impact_factor: "",
                                        no_of_citations: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.research_publications.length}
                                    onChange={(no) => {
                                      handle("research_publications", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.research_publications.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">S.No</th>
                                        <th scope="col">Author's (s) in order as appeared</th>
                                        <th scope="col">Title</th>
                                        <th scope="col">Name of Journal</th>
                                        <th scope="col">Volume No</th>
                                        <th scope="col">Volume Issue</th>
                                        <th scope="col">Year</th>
                                        <th scope="col">Listed</th>
                                        <th scope="col">Impact Factor</th>
                                        <th scope="col">
                                          Number of Citations as <br />
                                          per Google Scholar{" "}
                                        </th>
                                        <th scope="col">Attachment </th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.research_publications?.map((researchpublic, index) => {
                                        return (
                                          <tr key={researchpublic.id}>
                                            <td key={index}>{index + 1}</td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_author_name_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Author Name" defaultValue={researchpublic?.author_name} onChange={(e) => setData(e.target.value, "research_publications", "author_name", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.author_name?.message ? `Author Name ${validation?.research_publications[researchpublic.id.toString()]?.author_name?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={researchpublic?.title} onChange={(e) => setData(e.target.value, "research_publications", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.title?.message ? `Title ${validation?.research_publications[researchpublic.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_name_of_journal_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Name of Journal" defaultValue={researchpublic?.name_of_journal} onChange={(e) => setData(e.target.value, "research_publications", "name_of_journal", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.name_of_journal?.message ? `Name of Journal ${validation?.research_publications[researchpublic.id.toString()]?.name_of_journal?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_volume_no_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Volume No" defaultValue={researchpublic?.volume_no} onChange={(e) => setData(e.target.value, "research_publications", "volume_no", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.volume_no?.message ? `Volume No ${validation?.research_publications[researchpublic.id.toString()]?.volume_no?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_volume_issue_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Volume Issue" defaultValue={researchpublic?.volume_issue} onChange={(e) => setData(e.target.value, "research_publications", "volume_issue", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.volume_issue?.message ? `Volume Issue ${validation?.research_publications[researchpublic.id.toString()]?.volume_issue?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_year_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Year" maxLength={4} defaultValue={researchpublic?.year} onChange={(e) => setData(e.target.value, "research_publications", "year", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.year?.message ? `Year ${validation?.research_publications[researchpublic.id.toString()]?.year?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`research_publications_sci_scopus_ugc_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={researchpublic?.sci_scopus_ugc} onChange={(e) => setData(e.target.value, "research_publications", "sci_scopus_ugc", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="sci">SCI</option>
                                                  <option value="scopus_indexed">Scopus Indexed</option>
                                                  <option value="ugc_listed">UGC Listed</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.sci_scopus_ugc?.message ? `Type ${validation?.research_publications[researchpublic.id.toString()]?.sci_scopus_ugc?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_impact_factor_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Impact Factor" defaultValue={researchpublic?.impact_factor} onChange={(e) => setData(e.target.value, "research_publications", "impact_factor", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.impact_factor?.message ? `Impact Factor ${validation?.research_publications[researchpublic.id.toString()]?.impact_factor?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`research_publications_no_of_citations_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter No of Citations" defaultValue={researchpublic?.no_of_citations} onChange={(e) => setData(e.target.value, "research_publications", "no_of_citations", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_publications[researchpublic.id.toString()]?.no_of_citations?.message ? `No of Citations ${validation?.research_publications[researchpublic.id.toString()]?.no_of_citations?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "research_publications", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {researchpublic?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${researchpublic?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.research_publications?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("research_publications", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.research_publications?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("research_publications", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                f. Papers presented in national / international conference/seminar :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.papers_presentation.length}
                                    onChange={(yes) => {
                                      handle("papers_presentation", "yes", {
                                        id: 0,
                                        author_name: "",
                                        title: "",
                                        name_of_the_event: "",
                                        issn_volume: "",
                                        page_no: "",
                                        year: "",
                                        place: "",
                                        country: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.papers_presentation.length}
                                    onChange={(no) => {
                                      handle("papers_presentation", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.papers_presentation.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">
                                          Author (s) Name in order <br />
                                          as appeared
                                        </th>
                                        <th scope="col">Title</th>
                                        <th scope="col">
                                          Name of the <br /> Conference / Event
                                        </th>
                                        <th scope="col">ISSN Volume</th>
                                        <th scope="col">Page No</th>
                                        <th scope="col">Year</th>
                                        <th scope="col">Place</th>
                                        <th scope="col">Country</th>
                                        <th scope="col">Attachment </th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.papers_presentation?.map((paperpresent, index) => {
                                        return (
                                          <tr key={paperpresent.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_author_name_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Author Name" defaultValue={paperpresent?.author_name} onChange={(e) => setData(e.target.value, "papers_presentation", "author_name", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.author_name?.message ? `Author Name ${validation?.papers_presentation[paperpresent.id.toString()]?.author_name?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={paperpresent?.title} onChange={(e) => setData(e.target.value, "papers_presentation", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.title?.message ? `Title ${validation?.papers_presentation[paperpresent.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_name_of_the_event_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Name of Event" defaultValue={paperpresent?.name_of_the_event} onChange={(e) => setData(e.target.value, "papers_presentation", "name_of_the_event", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.name_of_the_event?.message ? `Name of Event ${validation?.papers_presentation[paperpresent.id.toString()]?.name_of_the_event?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_issn_volume_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter ISSN Volume" defaultValue={paperpresent?.issn_volume} onChange={(e) => setData(e.target.value, "papers_presentation", "issn_volume", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.issn_volume?.message ? `ISSN Volume ${validation?.papers_presentation[paperpresent.id.toString()]?.issn_volume?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_page_no_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Page No" defaultValue={paperpresent?.page_no} onChange={(e) => setData(e.target.value, "papers_presentation", "page_no", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.page_no?.message ? `Page No ${validation?.papers_presentation[paperpresent.id.toString()]?.page_no?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_year_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Year" maxLength={4} defaultValue={paperpresent?.year} onChange={(e) => setData(e.target.value, "papers_presentation", "year", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.year?.message ? `Year ${validation?.papers_presentation[paperpresent.id.toString()]?.year?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_place_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Place" defaultValue={paperpresent?.place} onChange={(e) => setData(e.target.value, "papers_presentation", "place", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.place?.message ? `Place ${validation?.papers_presentation[paperpresent.id.toString()]?.place?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`papers_presentation_country_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Country" defaultValue={paperpresent?.country} onChange={(e) => setData(e.target.value, "papers_presentation", "country", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.papers_presentation[paperpresent.id.toString()]?.country?.message ? `Country ${validation?.papers_presentation[paperpresent.id.toString()]?.country?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "papers_presentation", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {paperpresent?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${paperpresent?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.papers_presentation?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("papers_presentation", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.papers_presentation?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("papers_presentation", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                g. Books authored / Edited book / Edited proceedings / Book chapter / Monographs :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.books_authored.length}
                                    onChange={(yes) => {
                                      handle("books_authored", "yes", {
                                        id: 0,
                                        author_name: "",
                                        title: "",
                                        type_of_publications: "",
                                        isbn_issn: "",
                                        publisher_country: "",
                                        publisher_year: "",
                                        total_pages: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.books_authored.length}
                                    onChange={(no) => {
                                      handle("books_authored", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.books_authored.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">
                                          Author (s) Name in order <br />
                                          as appeared
                                        </th>
                                        <th scope="col">Title</th>
                                        <th scope="col">Type of Publications</th>
                                        <th scope="col">ISBN / ISSN</th>
                                        <th scope="col">Publisher Country</th>
                                        <th scope="col">Publisher Year</th>
                                        <th scope="col">Total Pages</th>
                                        <th scope="col">Attachment </th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.books_authored?.map((books, index) => {
                                        return (
                                          <tr key={books.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`books_authored_author_name_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Author Name" defaultValue={books?.author_name} onChange={(e) => setData(e.target.value, "books_authored", "author_name", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.books_authored[books.id.toString()]?.author_name?.message ? `Author Name ${validation?.books_authored[books.id.toString()]?.author_name?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`books_authored_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={books?.title} onChange={(e) => setData(e.target.value, "books_authored", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.books_authored[books.id.toString()]?.title?.message ? `Title ${validation?.books_authored[books.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`books_authored_type_of_publications_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Publications" defaultValue={books?.type_of_publications} onChange={(e) => setData(e.target.value, "books_authored", "type_of_publications", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.books_authored[books.id.toString()]?.type_of_publications?.message ? `Publications ${validation?.books_authored[books.id.toString()]?.type_of_publications?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`books_authored_isbn_issn_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={books?.isbn_issn} onChange={(e) => setData(e.target.value, "books_authored", "isbn_issn", index)}>
                                                  <option value="">Select Mode</option>
                                                  <option value="isbn">ISBN</option>
                                                  <option value="issn">ISSN</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.books_authored[books.id.toString()]?.isbn_issn?.message ? `Type ${validation?.books_authored[books.id.toString()]?.isbn_issn?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`books_authored_publisher_country_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Publisher Country" defaultValue={books?.publisher_country} onChange={(e) => setData(e.target.value, "books_authored", "publisher_country", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.books_authored[books.id.toString()]?.publisher_country?.message ? `Publisher Country ${validation?.books_authored[books.id.toString()]?.publisher_country?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`books_authored_publisher_year_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Publisher Year" maxLength={4} defaultValue={books?.publisher_year} onChange={(e) => setData(e.target.value, "books_authored", "publisher_year", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.books_authored[books.id.toString()]?.publisher_year?.message ? `Publisher Year ${validation?.books_authored[books.id.toString()]?.publisher_year?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`books_authored_total_pages_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Total Pages" defaultValue={books?.total_pages} onChange={(e) => setData(e.target.value, "books_authored", "total_pages", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.books_authored[books.id.toString()]?.total_pages?.message ? `Total Pages ${validation?.books_authored[books.id.toString()]?.total_pages?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "books_authored", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {books?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${books?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.books_authored?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("books_authored", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.books_authored?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("books_authored", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                h.Patents, copy right and technology transfer agreements signed :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.patents.length}
                                    onChange={(yes) => {
                                      handle("patents", "yes", {
                                        id: 0,
                                        title: "",
                                        type: "",
                                        registration_no: "",
                                        registration_date: "",
                                        ...(!IsOldReportYear(report) && { level: "" }),
                                        granted_or_filed: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.patents.length}
                                    onChange={(no) => {
                                      handle("patents", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.patents.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Title</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Registration No</th>
                                        <th scope="col">Registration Date</th>
                                        {!IsOldReportYear(report) &&
                                          <th scope="col">Level</th>
                                        }
                                        <th scope="col">Granted / Published</th>
                                        <th scope="col">Attachment </th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.patents?.map((patent, index) => {
                                        return (
                                          <tr key={patent.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`patents_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={patent?.title} onChange={(e) => setData(e.target.value, "patents", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.patents[patent.id.toString()]?.title?.message ? `Title ${validation?.patents[patent.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`patents_type_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={patent?.type} onChange={(e) => setData(e.target.value, "patents", "type", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="patents">Patents</option>
                                                  <option value="copy_right">Copy Right</option>
                                                  <option value="technology_transfer">Technology Transfer</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.patents[patent.id.toString()]?.type?.message ? `Type ${validation?.patents[patent.id.toString()]?.type?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`patents_registration_no_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Registration No" defaultValue={patent?.registration_no} onChange={(e) => setData(e.target.value, "patents", "registration_no", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.patents[patent.id.toString()]?.registration_no?.message ? `Registration No ${validation?.patents[patent.id.toString()]?.registration_no?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`patents_registration_date_${index}`] = el}
                                                  key={index} type="date" className="fieldinputreport" placeholder="Enter Registration Date" defaultValue={patent?.registration_date} onChange={(e) => setData(e.target.value, "patents", "registration_date", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.patents[patent.id.toString()]?.registration_date?.message ? `Registration Date ${validation?.patents[patent.id.toString()]?.registration_date?.message}` : ""}</small>
                                            </td>
                                            {!IsOldReportYear(report) &&
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefC.current[`patents_level_${index}`] = el}
                                                    key={index} className="fieldinputselectreport" defaultValue={patent?.level} onChange={(e) => setData(e.target.value, "patents", "level", index)}>
                                                    <option value="">Select Level</option>
                                                    <option value="national">National</option>
                                                    <option value="international">International</option>
                                                  </select>
                                                </div>
                                                <small className="validationerror">{validation?.patents[patent.id.toString()]?.level?.message ? `Level ${validation?.patents[patent.id.toString()]?.level?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`patents_granted_or_filed_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={patent?.granted_or_filed} onChange={(e) => setData(e.target.value, "patents", "granted_or_filed", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="granted">Granted</option>
                                                  <option value="published">Published</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.patents[patent.id.toString()]?.granted_or_filed?.message ? `Type ${validation?.patents[patent.id.toString()]?.granted_or_filed?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "patents", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {patent?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${patent?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.patents?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("patents", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.patents?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("patents", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                i. Honors / awards / medals/ fellowships for outstanding contributions :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.awards_details.length}
                                    onChange={(yes) => {
                                      handle("awards_details", "yes", {
                                        id: 0,
                                        name_of_the_award: "",
                                        awarding_institution: "",
                                        area_of_recognition: "",
                                        national_or_international: "",
                                        year: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.awards_details.length}
                                    onChange={(no) => {
                                      handle("awards_details", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.awards_details.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">
                                          Name of the Awards / Medals / <br /> Fellowships
                                        </th>
                                        <th scope="col">Awarding Institution</th>
                                        <th scope="col">Area of Recognition</th>
                                        <th scope="col">National / International</th>
                                        <th scope="col">Year</th>
                                        <th scope="col">Attachment </th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.awards_details?.map((award, index) => {
                                        return (
                                          <tr key={award.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`awards_details_name_of_the_award_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Name" defaultValue={award?.name_of_the_award} onChange={(e) => setData(e.target.value, "awards_details", "name_of_the_award", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.awards_details[award.id.toString()]?.name_of_the_award?.message ? `Name ${validation?.awards_details[award.id.toString()]?.name_of_the_award?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`awards_details_awarding_institution_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Awarding Institution" defaultValue={award?.awarding_institution} onChange={(e) => setData(e.target.value, "awards_details", "awarding_institution", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.awards_details[award.id.toString()]?.awarding_institution?.message ? `Awarding Institution ${validation?.awards_details[award.id.toString()]?.awarding_institution?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`awards_details_area_of_recognition_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Recognition Area" defaultValue={award?.area_of_recognition} onChange={(e) => setData(e.target.value, "awards_details", "area_of_recognition", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.awards_details[award.id.toString()]?.area_of_recognition?.message ? `Recognition Area ${validation?.awards_details[award.id.toString()]?.area_of_recognition?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefC.current[`awards_details_national_or_international_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={award?.national_or_international} onChange={(e) => setData(e.target.value, "awards_details", "national_or_international", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.awards_details[award.id.toString()]?.national_or_international?.message ? `Type ${validation?.awards_details[award.id.toString()]?.national_or_international?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefC.current[`awards_details_year_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Year" maxLength={4} defaultValue={award?.year} onChange={(e) => setData(e.target.value, "awards_details", "year", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.awards_details[award.id.toString()]?.year?.message ? `Year ${validation?.awards_details[award.id.toString()]?.year?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "awards_details", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {award?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${award?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.awards_details?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("awards_details", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.awards_details?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("awards_details", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {active === 3 && (
                        <>
                          <h5 className="centertext my-5">INSTITUTIONAL DEVELOPMENT</h5>
                          <div>
                            <div>
                              <h6 className="reporttitle">
                                a. Administrative Contributions :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.administrative_contributions.length}
                                    onChange={(yes) => {
                                      handle("administrative_contributions", "yes", {
                                        id: 0,
                                        position: "",
                                        ...(IsOldReportYear(report) && {
                                          from_date: "",
                                          to_date: "",
                                          experience: "",
                                        }),
                                        significant_contributions: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.administrative_contributions.length}
                                    onChange={(no) => {
                                      handle("administrative_contributions", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              <p>
                                ((i) Head of Department / centre / Extension Centre; (ii) Chairman / Member of Internal Committees / Board of Studies / Academic Council / Academic Responsibilities; (iii) Warden / CVO / PIO / Nodal Officer / IQAC; <br />
                                (iv) In-charge of Maintenance - Civil / Electrical / Networking / Air-condition / Web site / Computer / Vehicle / Security)
                              </p>
                              {report?.administrative_contributions.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Position</th>
                                        {IsOldReportYear(report) &&
                                          <>
                                            <th scope="col">
                                              Duration
                                              <table className="table">
                                                <tr>
                                                  <td className="w-50">From</td>
                                                  <td className="w-50">To</td>
                                                </tr>
                                              </table>
                                            </th>
                                            <th scope="col">Experience (YY-MM)</th>
                                          </>
                                        }
                                        <th scope="col">Significant Contributions</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.administrative_contributions?.map((admincontribute, index) => {
                                        return (
                                          <tr key={admincontribute.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`administrative_contributions_position_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Position" defaultValue={admincontribute?.position} onChange={(e) => setData(e.target.value, "administrative_contributions", "position", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.administrative_contributions[admincontribute.id.toString()]?.position?.message ? `Position ${validation?.administrative_contributions[admincontribute.id.toString()]?.position?.message}` : ""}</small>
                                            </td>
                                            {IsOldReportYear(report) &&
                                              <>
                                                <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                                  <div className="me-2 mb27">
                                                    <div>
                                                      <input
                                                        ref={el => inputRefD.current[`administrative_contributions_from_date_${index}`] = el}
                                                        type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={admincontribute?.from_date} onChange={(e) => setData(e.target.value, "administrative_contributions", "from_date", index)} />
                                                    </div>
                                                    <small className="validationerror">{validation?.administrative_contributions[admincontribute.id.toString()]?.from_date?.message ? `From Date ${validation?.administrative_contributions[admincontribute.id.toString()]?.from_date?.message}` : ""}</small>
                                                  </div>
                                                  <div>
                                                    <div>
                                                      <input
                                                        type="date"
                                                        ref={el => inputRefD.current[`administrative_contributions_to_date_${index}`] = el}
                                                        className="fieldinputreport"
                                                        placeholder="Enter"
                                                        key={index}
                                                        defaultValue={admincontribute?.to_date}
                                                        onChange={(e) => setData(e.target.value, "administrative_contributions", "to_date", index)}
                                                        min={moment(admincontribute?.from_date).format("yyyy-MM-DD")}
                                                      />
                                                    </div>
                                                    <small className="validationerror">{validation?.administrative_contributions[admincontribute.id.toString()]?.to_date?.message ? `To Date ${validation?.administrative_contributions[admincontribute.id.toString()]?.to_date?.message}` : ""}</small>
                                                  </div>
                                                </td>
                                                <td>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefD.current[`administrative_contributions_experience_${index}`] = el}
                                                      key={index} type="text" className="fieldinputreport" placeholder="Enter Experience (YY-MM)" maxLength={5} defaultValue={admincontribute?.experience} onChange={(e) => setData(e.target.value, "administrative_contributions", "experience", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.administrative_contributions[admincontribute.id.toString()]?.experience?.message ? `Experience ${validation?.administrative_contributions[admincontribute.id.toString()]?.experience?.message}` : ""}</small>
                                                </td>
                                              </>
                                            }
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`administrative_contributions_significant_contributions_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Significant Contributions" defaultValue={admincontribute?.significant_contributions} onChange={(e) => setData(e.target.value, "administrative_contributions", "significant_contributions", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.administrative_contributions[admincontribute.id.toString()]?.significant_contributions?.message ? `Significant Contributions ${validation?.administrative_contributions[admincontribute.id.toString()]?.significant_contributions?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              {report?.administrative_contributions?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("administrative_contributions", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.administrative_contributions?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("administrative_contributions", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                b. Infrastructure developed with internal / external funding for improvement in science and technology :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.infrastructure_development.length}
                                    onChange={(yes) => {
                                      handle("infrastructure_development", "yes", {
                                        id: 0,
                                        type: "",
                                        others: "",
                                        funding_agency: "",
                                        from_date: "",
                                        to_date: "",
                                        pi_or_co_pi: "",
                                        salient_contributions: "",
                                        amount: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.infrastructure_development.length}
                                    onChange={(no) => {
                                      handle("infrastructure_development", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.infrastructure_development.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Infrastructure Development</th>
                                        <th scope="col">Others</th>
                                        <th scope="col">Funding Agency</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">PI or Co-PI</th>
                                        <th scope="col">Salient Contributions</th>
                                        <th scope="col">
                                          Amount of Grant <br /> (Rs. in lakhs)
                                        </th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.infrastructure_development?.map((infra, index) => {
                                        return (
                                          <tr key={infra.id}>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefD.current[`infrastructure_development_type_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={infra?.type} onChange={(e) => setData(e.target.value, "infrastructure_development", "type", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="laboaratory_development">Laboaratory Development</option>
                                                  <option value="others">Others (specify)</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.type?.message ? `Type ${validation?.infrastructure_development[infra.id.toString()]?.type?.message}` : ""}</small>
                                            </td>
                                            {infra?.type === "others" ? (
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefD.current[`infrastructure_development_others_${index}`] = el}
                                                    key={index} type="text" className="fieldinputreport" placeholder="Enter Others" defaultValue={infra?.others} onChange={(e) => setData(e.target.value, "infrastructure_development", "others", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.others?.message ? `Others ${validation?.infrastructure_development[infra.id.toString()]?.others?.message}` : ""}</small>
                                              </td>
                                            ) : (
                                              <td>
                                                <input key={index} type="text" className="fieldinputreport" placeholder="Enter Others" disabled />
                                              </td>
                                            )}

                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`infrastructure_development_funding_agency_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Funding Agency" defaultValue={infra?.funding_agency} onChange={(e) => setData(e.target.value, "infrastructure_development", "funding_agency", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.funding_agency?.message ? `Funding Agency ${validation?.infrastructure_development[infra.id.toString()]?.funding_agency?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefD.current[`infrastructure_development_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={infra?.from_date} onChange={(e) => setData(e.target.value, "infrastructure_development", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.from_date?.message ? `From Date ${validation?.infrastructure_development[infra.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefD.current[`infrastructure_development_to_date_${index}`] = el}
                                                    type="date"
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={infra?.to_date}
                                                    onChange={(e) => setData(e.target.value, "infrastructure_development", "to_date", index)}
                                                    min={moment(infra?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.to_date?.message ? `To Date ${validation?.infrastructure_development[infra.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefD.current[`infrastructure_development_pi_or_co_pi_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={infra?.pi_or_co_pi} onChange={(e) => setData(e.target.value, "infrastructure_development", "pi_or_co_pi", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="pi">PI</option>
                                                  <option value="co_pi">Co-PI</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.pi_or_co_pi?.message ? `Type ${validation?.infrastructure_development[infra.id.toString()]?.pi_or_co_pi?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`infrastructure_development_salient_contributions_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Salient Contributions" defaultValue={infra?.salient_contributions} onChange={(e) => setData(e.target.value, "infrastructure_development", "salient_contributions", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.salient_contributions?.message ? `Salient Contributions ${validation?.infrastructure_development[infra.id.toString()]?.salient_contributions?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`infrastructure_development_amount_${index}`] = el}
                                                  key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Amount" defaultValue={infra?.amount} onChange={(e) => setData(e.target.value, "infrastructure_development", "amount", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.infrastructure_development[infra.id.toString()]?.amount?.message ? `Amount ${validation?.infrastructure_development[infra.id.toString()]?.amount?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              {report?.infrastructure_development?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("infrastructure_development", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.infrastructure_development?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("infrastructure_development", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>Total amount of grant</td>
                                        <td>{calculateSum(report?.infrastructure_development, 'amount')}</td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            {IsOldReportYear(report) &&
                              <div>
                                <h6 className="reporttitle">
                                  c. Revenue generated through Training Programmes as Co-ordinator / Other Avenues :
                                  <label>
                                    <input
                                      className="ratiobuttonalign"
                                      type="radio"
                                      checked={report?.revenue_generated_through_training_program.length}
                                      onChange={(yes) => {
                                        handle("revenue_generated_through_training_program", "yes", {
                                          id: 0,
                                          academic_event: "",
                                          title_of_event: "",
                                          national_or_international: "",
                                          role: "",
                                          amount: "",
                                          attachment: "",
                                        });
                                      }}
                                    />
                                    &nbsp;Yes
                                  </label>
                                  <label>
                                    <input
                                      className="ratiobuttonalign"
                                      type="radio"
                                      checked={!report?.revenue_generated_through_training_program.length}
                                      onChange={(no) => {
                                        handle("revenue_generated_through_training_program", "no");
                                      }}
                                    />
                                    &nbsp;No
                                  </label>
                                </h6>
                                {report?.revenue_generated_through_training_program.length > 0 && (
                                  <div className="scroll-table">
                                    <table className="table table-hover">
                                      <thead>
                                        <tr>
                                          <th scope="col">Academic Event</th>
                                          <th scope="col">Title of Event</th>
                                          <th scope="col">National / International</th>
                                          <th scope="col">Role</th>
                                          <th scope="col">Amount (Rs. in lakhs)</th>
                                          <th scope="col">Attachment</th>
                                          <th scope="col">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {report?.revenue_generated_through_training_program?.map((revenuegen, index) => {
                                          return (
                                            <tr key={revenuegen.id}>
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefD.current[`revenue_generated_through_training_program_academic_event_${index}`] = el}
                                                    key={index} type="text" className="fieldinputreport" placeholder="Enter Academic Event" defaultValue={revenuegen?.academic_event} onChange={(e) => setData(e.target.value, "revenue_generated_through_training_program", "academic_event", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.academic_event?.message ? `Academic Event ${validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.academic_event?.message}` : ""}</small>
                                              </td>
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefD.current[`revenue_generated_through_training_program_title_of_event_${index}`] = el}
                                                    key={index} type="text" className="fieldinputreport" placeholder="Enter Event Title" defaultValue={revenuegen?.title_of_event} onChange={(e) => setData(e.target.value, "revenue_generated_through_training_program", "title_of_event", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.title_of_event?.message ? `Event Title ${validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.title_of_event?.message}` : ""}</small>
                                              </td>
                                              <td>
                                                <div>
                                                  <select
                                                    ref={el => inputRefD.current[`revenue_generated_through_training_program_national_or_international_${index}`] = el}
                                                    key={index} className="fieldinputselectreport" defaultValue={revenuegen?.national_or_international} onChange={(e) => setData(e.target.value, "revenue_generated_through_training_program", "national_or_international", index)}>
                                                    <option value="">Select Type</option>
                                                    <option value="national">National</option>
                                                    <option value="international">International</option>
                                                  </select>
                                                </div>
                                                <small className="validationerror">{validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.national_or_international?.message ? `Type ${validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.national_or_international?.message}` : ""}</small>
                                              </td>
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefD.current[`revenue_generated_through_training_program_role_${index}`] = el}
                                                    key={index} type="text" className="fieldinputreport" placeholder="Enter Role" defaultValue={revenuegen?.role} onChange={(e) => setData(e.target.value, "revenue_generated_through_training_program", "role", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.role?.message ? `Role ${validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.role?.message}` : ""}</small>
                                              </td>
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefD.current[`revenue_generated_through_training_program_amount_${index}`] = el}
                                                    key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Amount" defaultValue={revenuegen?.amount} onChange={(e) => setData(e.target.value, "revenue_generated_through_training_program", "amount", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.amount?.message ? `Amount ${validation?.revenue_generated_through_training_program[revenuegen.id.toString()]?.amount?.message}` : ""}</small>
                                              </td>
                                              <td>
                                                <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "revenue_generated_through_training_program", "attachment", index)} accept="application/pdf" />
                                                <br />
                                                <small className="d-flex">Max File upload:200kb</small>
                                                <br />
                                                {revenuegen?.attachment ? (
                                                  <span
                                                    className="namelink"
                                                    onClick={() => {


                                                      window.open(`${imagepath}${revenuegen?.attachment}`, "_blank");
                                                    }}
                                                  >
                                                    View Document
                                                  </span>
                                                ) : (
                                                  ""
                                                )}
                                              </td>
                                              <td>
                                                {report?.revenue_generated_through_training_program?.length - 1 === index && (
                                                  <span
                                                    className="material-symbols-outlined addoption"
                                                    type="button"
                                                    onClick={() => {
                                                      setAddArrayData("revenue_generated_through_training_program", index);
                                                    }}
                                                  >
                                                    add
                                                  </span>
                                                )}
                                                {report?.revenue_generated_through_training_program?.length !== 1 && (
                                                  <span
                                                    className="material-symbols-outlined removeoption"
                                                    type="button"
                                                    onClick={() => {
                                                      setRemoveArrayData("revenue_generated_through_training_program", index);
                                                    }}
                                                  >
                                                    remove
                                                  </span>
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            }
                            <div>
                              <h6 className="reporttitle">
                                {IsOldReportYear(report) ? 'd. ' : 'c. '}
                                Research / academic events (workshop / conference / seminar / webinar / programmes under national initiatives) organized at national / international level :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.research_or_academic_events.length}
                                    onChange={(yes) => {
                                      handle("research_or_academic_events", "yes", {
                                        id: 0,
                                        academic_event: "",
                                        title_of_event: "",
                                        date: "",
                                        role: "",
                                        no_of_participants: "",
                                        national_or_international: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.research_or_academic_events.length}
                                    onChange={(no) => {
                                      handle("research_or_academic_events", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.research_or_academic_events.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Academic Event</th>
                                        <th scope="col">Title of Event</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Role</th>
                                        <th scope="col">No.of Participants</th>
                                        <th scope="col">National / International</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.research_or_academic_events?.map((infra, index) => {
                                        return (
                                          <tr key={infra.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`research_or_academic_events_academic_event_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Academic Event" defaultValue={infra?.academic_event} onChange={(e) => setData(e.target.value, "research_or_academic_events", "academic_event", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_or_academic_events[infra.id.toString()]?.academic_event?.message ? `Academic Event ${validation?.research_or_academic_events[infra.id.toString()]?.academic_event?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`research_or_academic_events_title_of_event_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Event Title" defaultValue={infra?.title_of_event} onChange={(e) => setData(e.target.value, "research_or_academic_events", "title_of_event", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_or_academic_events[infra.id.toString()]?.title_of_event?.message ? `Event Title ${validation?.research_or_academic_events[infra.id.toString()]?.title_of_event?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`research_or_academic_events_date_${index}`] = el}
                                                  key={index} type="date" className="fieldinputreport" placeholder="Enter Event Title" defaultValue={infra?.date} onChange={(e) => setData(e.target.value, "research_or_academic_events", "date", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_or_academic_events[infra.id.toString()]?.date?.message ? `Date ${validation?.research_or_academic_events[infra.id.toString()]?.date?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`research_or_academic_events_role_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Role" defaultValue={infra?.role} onChange={(e) => setData(e.target.value, "research_or_academic_events", "role", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_or_academic_events[infra.id.toString()]?.role?.message ? `Role ${validation?.research_or_academic_events[infra.id.toString()]?.role?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`research_or_academic_events_no_of_participants_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter No of Participants" defaultValue={infra?.no_of_participants} onChange={(e) => setData(e.target.value, "research_or_academic_events", "no_of_participants", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.research_or_academic_events[infra.id.toString()]?.no_of_participants?.message ? `Participants Count ${validation?.research_or_academic_events[infra.id.toString()]?.no_of_participants?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefD.current[`research_or_academic_events_national_or_international_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={infra?.national_or_international} onChange={(e) => setData(e.target.value, "research_or_academic_events", "national_or_international", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.research_or_academic_events[infra.id.toString()]?.national_or_international?.message ? `Type ${validation?.research_or_academic_events[infra.id.toString()]?.national_or_international?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              {report?.research_or_academic_events?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("research_or_academic_events", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.research_or_academic_events?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("research_or_academic_events", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                              <i># As Organizing Committee Chairname / Secretary / Member / Advisory Committee Member & Others</i>
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                {IsOldReportYear(report) ? 'e. ' : 'd. '}
                                Events conducted in collaboration with Industry :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.events_conducted.length}
                                    onChange={(yes) => {
                                      handle("events_conducted", "yes", {
                                        id: 0,
                                        title_of_event: "",
                                        date: "",
                                        role: "",
                                        no_of_participants: "",
                                        name_of_the_industry: "",
                                        revenue_generated: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.events_conducted.length}
                                    onChange={(no) => {
                                      handle("events_conducted", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.events_conducted.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Title of Event</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Role</th>
                                        <th scope="col">No.of Participants</th>
                                        <th scope="col">Name of the Industry</th>
                                        <th scope="col">Revenue Generated (if applicable)</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.events_conducted?.map((eventconduct, index) => {
                                        return (
                                          <tr key={eventconduct.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`events_conducted_title_of_event_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Event Title" defaultValue={eventconduct?.title_of_event} onChange={(e) => setData(e.target.value, "events_conducted", "title_of_event", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.events_conducted[eventconduct.id.toString()]?.title_of_event?.message ? `Event Title ${validation?.events_conducted[eventconduct.id.toString()]?.title_of_event?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`events_conducted_date_${index}`] = el}
                                                  key={index} type="date" className="fieldinputreport" placeholder="Enter Event Title" defaultValue={eventconduct?.date} onChange={(e) => setData(e.target.value, "events_conducted", "date", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.events_conducted[eventconduct.id.toString()]?.date?.message ? `Date ${validation?.events_conducted[eventconduct.id.toString()]?.date?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`events_conducted_role_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Role" defaultValue={eventconduct?.role} onChange={(e) => setData(e.target.value, "events_conducted", "role", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.events_conducted[eventconduct.id.toString()]?.role?.message ? `Role ${validation?.events_conducted[eventconduct.id.toString()]?.role?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`events_conducted_no_of_participants_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter No of Participants" defaultValue={eventconduct?.no_of_participants} onChange={(e) => setData(e.target.value, "events_conducted", "no_of_participants", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.events_conducted[eventconduct.id.toString()]?.no_of_participants?.message ? `Participants Count ${validation?.events_conducted[eventconduct.id.toString()]?.no_of_participants?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`events_conducted_name_of_the_industry_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Industry Name" defaultValue={eventconduct?.name_of_the_industry} onChange={(e) => setData(e.target.value, "events_conducted", "name_of_the_industry", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.events_conducted[eventconduct.id.toString()]?.name_of_the_industry?.message ? `Industry Name ${validation?.events_conducted[eventconduct.id.toString()]?.name_of_the_industry?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`events_conducted_revenue_generated_${index}`] = el}
                                                  key={index} type="number" className="fieldinputreport" placeholder="Enter Revenue" defaultValue={eventconduct?.revenue_generated} onChange={(e) => setData(e.target.value, "events_conducted", "revenue_generated", index)} />
                                              </div>
                                              <small className="d-flex">If not applicable ,enter 0</small><br />
                                              <small className="validationerror">{validation?.events_conducted[eventconduct.id.toString()]?.revenue_generated?.message ? `Revenue ${validation?.events_conducted[eventconduct.id.toString()]?.revenue_generated?.message}` : ""}</small>

                                            </td>
                                            <td>
                                              {report?.events_conducted?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("events_conducted", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.events_conducted?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("events_conducted", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                              <i># As Organizing Committee Chairname / Secretary / Member / Advisory Committee Member & Others</i>
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                {IsOldReportYear(report) ? 'f. ' : 'e. '}
                                New initiatives implemented for the Institute Development :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.new_initiatives.length}
                                    onChange={(yes) => {
                                      handle("new_initiatives", "yes", {
                                        id: 0,
                                        initiative_implemented: "",
                                        type_of_benefit: "",
                                        revenue_generated: "",
                                        role: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.new_initiatives.length}
                                    onChange={(no) => {
                                      handle("new_initiatives", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.new_initiatives.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Initiative Implemented</th>
                                        <th scope="col">Type of Benefit to the Institute</th>
                                        <th scope="col">Revenue Generated (if applicable)</th>
                                        <th scope="col">Role</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.new_initiatives?.map((newinit, index) => {
                                        return (
                                          <tr key={newinit.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`new_initiatives_initiative_implemented_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Initiative Implemented" defaultValue={newinit?.initiative_implemented} onChange={(e) => setData(e.target.value, "new_initiatives", "initiative_implemented", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.new_initiatives[newinit.id.toString()]?.initiative_implemented?.message ? `Initiative Implemented ${validation?.new_initiatives[newinit.id.toString()]?.initiative_implemented?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`new_initiatives_type_of_benefit_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Benefit Type" defaultValue={newinit?.type_of_benefit} onChange={(e) => setData(e.target.value, "new_initiatives", "type_of_benefit", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.new_initiatives[newinit.id.toString()]?.type_of_benefit?.message ? `Benefit Type ${validation?.new_initiatives[newinit.id.toString()]?.type_of_benefit?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`new_initiatives_revenue_generated_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Revenue" defaultValue={newinit?.revenue_generated} onChange={(e) => setData(e.target.value, "new_initiatives", "revenue_generated", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.new_initiatives[newinit.id.toString()]?.revenue_generated?.message ? `Revenue ${validation?.new_initiatives[newinit.id.toString()]?.revenue_generated?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefD.current[`new_initiatives_role_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Role" defaultValue={newinit?.role} onChange={(e) => setData(e.target.value, "new_initiatives", "role", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.new_initiatives[newinit.id.toString()]?.role?.message ? `Role ${validation?.new_initiatives[newinit.id.toString()]?.role?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              {report?.new_initiatives?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("new_initiatives", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.new_initiatives?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("new_initiatives", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {active === 4 && (
                        <>
                          <h5 className="centertext my-5">PROFESSIONAL CONTRIBUTIONS</h5>
                          <div>
                            <div>
                              <h6 className="reporttitle">
                                a. Resource person in Training Programmes / Workshops (External) :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.resource_person_in_training_programmes.length}
                                    onChange={(yes) => {
                                      handle("resource_person_in_training_programmes", "yes", {
                                        id: 0,
                                        title: "",
                                        mode: "",
                                        conducted_at: "",
                                        from_date: "",
                                        to_date: "",
                                        no_of_hours: "",
                                        level: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.resource_person_in_training_programmes.length}
                                    onChange={(no) => {
                                      handle("resource_person_in_training_programmes", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.resource_person_in_training_programmes.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Title of the Program</th>
                                        <th scope="col">Mode</th>
                                        <th scope="col">Conducted at</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">No.of Hours Handled</th>
                                        <th scope="col">Level</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.resource_person_in_training_programmes?.map((resourceperson, index) => {
                                        return (
                                          <tr key={resourceperson.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`resource_person_in_training_programmes_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={resourceperson?.title} onChange={(e) => setData(e.target.value, "resource_person_in_training_programmes", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.title?.message ? `Title ${validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`resource_person_in_training_programmes_mode_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={resourceperson?.mode} onChange={(e) => setData(e.target.value, "resource_person_in_training_programmes", "mode", index)}>
                                                  <option value="">Select Mode</option>
                                                  <option value="contact">Contact</option>
                                                  <option value="online">Online</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.mode?.message ? `Mode ${validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.mode?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`resource_person_in_training_programmes_conducted_at_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Conducted At" defaultValue={resourceperson?.conducted_at} onChange={(e) => setData(e.target.value, "resource_person_in_training_programmes", "conducted_at", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.conducted_at?.message ? `Conducted At ${validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.conducted_at?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`resource_person_in_training_programmes_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={resourceperson?.from_date} onChange={(e) => setData(e.target.value, "resource_person_in_training_programmes", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.from_date?.message ? `From Date ${validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    type="date"
                                                    ref={el => inputRefE.current[`resource_person_in_training_programmes_to_date_${index}`] = el}
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={resourceperson?.to_date}
                                                    onChange={(e) => setData(e.target.value, "resource_person_in_training_programmes", "to_date", index)}
                                                    min={moment(resourceperson?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.to_date?.message ? `To Date ${validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`resource_person_in_training_programmes_no_of_hours_${index}`] = el}
                                                  key={index} type="number" onKeyDown={(e) => Restrict(e)} className="fieldinputreport" placeholder="Enter Hours Handled" defaultValue={resourceperson?.no_of_hours} onChange={(e) => setData(e.target.value, "resource_person_in_training_programmes", "no_of_hours", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.no_of_hours?.message ? `Hours Handled ${validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.no_of_hours?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`resource_person_in_training_programmes_level_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={resourceperson?.level} onChange={(e) => setData(e.target.value, "resource_person_in_training_programmes", "level", index)}>
                                                  <option value="">Select Level</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.level?.message ? `Level ${validation?.resource_person_in_training_programmes[resourceperson.id.toString()]?.level?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "resource_person_in_training_programmes", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {resourceperson?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${resourceperson?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.resource_person_in_training_programmes?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("resource_person_in_training_programmes", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.resource_person_in_training_programmes?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("resource_person_in_training_programmes", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>Total numbers of hours handled</td>
                                        <td>{calculateSum(report?.resource_person_in_training_programmes, 'no_of_hours')}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                b. Training programmes attended :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.training_programmes_attended.length}
                                    onChange={(yes) => {
                                      handle("training_programmes_attended", "yes", {
                                        id: 0,
                                        title: "",
                                        host_institution: "",
                                        sponsoring_agency: "",
                                        from_date: "",
                                        to_date: "",
                                        no_of_hours: "",
                                        national_or_international: "",
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.training_programmes_attended.length}
                                    onChange={(no) => {
                                      handle("training_programmes_attended", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.training_programmes_attended.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Title of the Training</th>
                                        <th scope="col">Host Institution</th>
                                        <th scope="col">Sponsoring Agency</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">Level</th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.training_programmes_attended?.map((trainprogram, index) => {
                                        return (
                                          <tr key={trainprogram.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`training_programmes_attended_title_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title" defaultValue={trainprogram?.title} onChange={(e) => setData(e.target.value, "training_programmes_attended", "title", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.training_programmes_attended[trainprogram.id.toString()]?.title?.message ? `Title ${validation?.training_programmes_attended[trainprogram.id.toString()]?.title?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`training_programmes_attended_host_institution_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Host Institution" defaultValue={trainprogram?.host_institution} onChange={(e) => setData(e.target.value, "training_programmes_attended", "host_institution", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.training_programmes_attended[trainprogram.id.toString()]?.host_institution?.message ? `Host Institution ${validation?.training_programmes_attended[trainprogram.id.toString()]?.host_institution?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`training_programmes_attended_sponsoring_agency_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Sponsoring Agency" defaultValue={trainprogram?.sponsoring_agency} onChange={(e) => setData(e.target.value, "training_programmes_attended", "sponsoring_agency", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.training_programmes_attended[trainprogram.id.toString()]?.sponsoring_agency?.message ? `Sponsoring Agency ${validation?.training_programmes_attended[trainprogram.id.toString()]?.sponsoring_agency?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`training_programmes_attended_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={trainprogram?.from_date} onChange={(e) => setData(e.target.value, "training_programmes_attended", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.training_programmes_attended[trainprogram.id.toString()]?.from_date?.message ? `From Date ${validation?.training_programmes_attended[trainprogram.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    type="date"
                                                    ref={el => inputRefE.current[`training_programmes_attended_to_date_${index}`] = el}
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={trainprogram?.to_date}
                                                    onChange={(e) => setData(e.target.value, "training_programmes_attended", "to_date", index)}
                                                    min={moment(trainprogram?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.training_programmes_attended[trainprogram.id.toString()]?.to_date?.message ? `To Date ${validation?.training_programmes_attended[trainprogram.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`training_programmes_attended_national_or_international_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={trainprogram?.national_or_international} onChange={(e) => setData(e.target.value, "training_programmes_attended", "national_or_international", index)}>
                                                  <option value="">Select Level</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.training_programmes_attended[trainprogram.id.toString()]?.national_or_international?.message ? `Level ${validation?.training_programmes_attended[trainprogram.id.toString()]?.national_or_international?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "training_programmes_attended", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {trainprogram?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${trainprogram?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.training_programmes_attended?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("training_programmes_attended", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.training_programmes_attended?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("training_programmes_attended", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                c. Participation and academic contributions in the area of your professional expertise at <br />
                                State / National/ International Level :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.participation_and_academic_contributions.length}
                                    onChange={(yes) => {
                                      handle("participation_and_academic_contributions", "yes", {
                                        id: 0,
                                        assignment: "",
                                        organization: "",
                                        nature_of_duty: "",
                                        from_date: "",
                                        to_date: "",
                                        ...(IsOldReportYear(report) && { experience: "" }),
                                        level: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.participation_and_academic_contributions.length}
                                    onChange={(no) => {
                                      handle("participation_and_academic_contributions", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.participation_and_academic_contributions.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Assignment</th>
                                        <th scope="col">Organization</th>
                                        <th scope="col">Nature of Duty</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="w-50">From</td>
                                              <td className="w-50">To</td>
                                            </tr>
                                          </table>
                                        </th>
                                        {IsOldReportYear(report) &&
                                          <th scope="col">Experience (YY-MM)</th>
                                        }
                                        <th scope="col">Level</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.participation_and_academic_contributions?.map((participat, index) => {
                                        return (
                                          <tr key={participat.id}>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`participation_and_academic_contributions_assignment_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={participat?.assignment} onChange={(e) => setData(e.target.value, "participation_and_academic_contributions", "assignment", index)}>
                                                  <option value="">Select Assignment</option>
                                                  <option value="national_coordinator">National Coordinator</option>
                                                  <option value="resource_person">Resource Person</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.participation_and_academic_contributions[participat.id.toString()]?.assignment?.message ? `Assignment ${validation?.participation_and_academic_contributions[participat.id.toString()]?.assignment?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`participation_and_academic_contributions_organization_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Organization" defaultValue={participat?.organization} onChange={(e) => setData(e.target.value, "participation_and_academic_contributions", "organization", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.participation_and_academic_contributions[participat.id.toString()]?.organization?.message ? `Organization ${validation?.participation_and_academic_contributions[participat.id.toString()]?.organization?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`participation_and_academic_contributions_nature_of_duty_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Nature of Duty" defaultValue={participat?.nature_of_duty} onChange={(e) => setData(e.target.value, "participation_and_academic_contributions", "nature_of_duty", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.participation_and_academic_contributions[participat.id.toString()]?.nature_of_duty?.message ? `Nature of Duty ${validation?.participation_and_academic_contributions[participat.id.toString()]?.nature_of_duty?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`participation_and_academic_contributions_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={participat?.from_date} onChange={(e) => setData(e.target.value, "participation_and_academic_contributions", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.participation_and_academic_contributions[participat.id.toString()]?.from_date?.message ? `From Date ${validation?.participation_and_academic_contributions[participat.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    type="date"
                                                    ref={el => inputRefE.current[`participation_and_academic_contributions_to_date_${index}`] = el}
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={participat?.to_date}
                                                    onChange={(e) => setData(e.target.value, "participation_and_academic_contributions", "to_date", index)}
                                                    min={moment(participat?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.participation_and_academic_contributions[participat.id.toString()]?.to_date?.message ? `From Date ${validation?.participation_and_academic_contributions[participat.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            {IsOldReportYear(report) &&
                                              <td>
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`participation_and_academic_contributions_experience_${index}`] = el}
                                                    key={index} type="text" className="fieldinputreport" placeholder="Enter Experience" maxLength={5} defaultValue={participat?.experience} onChange={(e) => setData(e.target.value, "participation_and_academic_contributions", "experience", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.participation_and_academic_contributions[participat.id.toString()]?.experience?.message ? `Experience ${validation?.participation_and_academic_contributions[participat.id.toString()]?.experience?.message}` : ""}</small>
                                              </td>
                                            }
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`participation_and_academic_contributions_level_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" value={participat?.level} onChange={(e) => setData(e.target.value, "participation_and_academic_contributions", "level", index)}>
                                                  <option value="">Select Level</option>
                                                  <option value="state">State</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.participation_and_academic_contributions[participat.id.toString()]?.level?.message ? `Type ${validation?.participation_and_academic_contributions[participat.id.toString()]?.level?.message}` : ""}</small>
                                            </td>

                                            <td>
                                              {report?.participation_and_academic_contributions?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("participation_and_academic_contributions", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.participation_and_academic_contributions?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("participation_and_academic_contributions", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                              <p>
                                Chairman / Member in board of studies / academic councils / executive committees
                                <br /> *MOOC / NRC / CDTP / Others <br /> # Invited lectures : Question paper setting & evaluator; Thesis examiner; Screening / Assessment / Selection Committee Member Chairing / Co-chairing / rapporteur in conference / seminar / workshop;Accreditation; and Paricipated meetings of AICTE / MoE / MEA / BoG; Any other external agencies
                              </p>
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                d. Overseas visited for Academic Events / Plenary Lectures / Invited Talks / part of Delegation / Others :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.overseas_visited_for_academic_events.length}
                                    onChange={(yes) => {
                                      handle("overseas_visited_for_academic_events", "yes", {
                                        id: 0,
                                        organization_or_university: "",
                                        city: "",
                                        country: "",
                                        institution_sponsored: "",
                                        nature_of_visit: "",
                                        from_date: "",
                                        to_date: "",
                                        ...(IsOldReportYear(report) && { duration: "" }),
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.overseas_visited_for_academic_events.length}
                                    onChange={(no) => {
                                      handle("overseas_visited_for_academic_events", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.overseas_visited_for_academic_events.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Organization / University Visited</th>
                                        <th scope="col">City Visited</th>
                                        <th scope="col">Country Visited</th>
                                        <th scope="col">Institution Sponsored the visit</th>
                                        <th scope="col">Nature of Visit</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="">From</td>
                                              <td className="">To</td>
                                              {IsOldReportYear(report) &&
                                                <td>YY-MM</td>
                                              }
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.overseas_visited_for_academic_events?.map((overseas, index) => {
                                        return (
                                          <tr key={overseas.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`overseas_visited_for_academic_events_organization_or_university_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Organization or University" defaultValue={overseas?.organization_or_university} onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "organization_or_university", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.organization_or_university?.message ? `Name ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.organization_or_university?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`overseas_visited_for_academic_events_city_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter City" defaultValue={overseas?.city} onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "city", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.city?.message ? `City ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.city?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`overseas_visited_for_academic_events_country_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Country" defaultValue={overseas?.country} onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "country", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.country?.message ? `Country ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.country?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`overseas_visited_for_academic_events_institution_sponsored_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Institution Sponsored" defaultValue={overseas?.institution_sponsored} onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "institution_sponsored", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.institution_sponsored?.message ? `Institution Sponsored ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.institution_sponsored?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`overseas_visited_for_academic_events_nature_of_visit_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Nature of Visit" defaultValue={overseas?.nature_of_visit} onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "nature_of_visit", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.nature_of_visit?.message ? `Nature of Visit ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.nature_of_visit?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`overseas_visited_for_academic_events_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={overseas?.from_date} onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.from_date?.message ? `From Date ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`overseas_visited_for_academic_events_to_date_${index}`] = el}
                                                    type="date"
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={overseas?.to_date}
                                                    onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "to_date", index)}
                                                    min={moment(overseas?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.to_date?.message ? `TO Date ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                              {IsOldReportYear(report) &&
                                                <td>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefE.current[`overseas_visited_for_academic_events_duration_${index}`] = el}
                                                      type="text" className="fieldinputreport" placeholder="Enter YY-MM" maxLength={5} key={index} defaultValue={overseas.duration} onChange={(e) => setData(e.target.value, "overseas_visited_for_academic_events", "duration", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.duration?.message ? `Duration ${validation?.overseas_visited_for_academic_events[overseas.id.toString()]?.duration?.message}` : ""}</small>
                                                </td>
                                              }

                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "overseas_visited_for_academic_events", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {overseas?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${overseas?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.overseas_visited_for_academic_events?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("overseas_visited_for_academic_events", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.overseas_visited_for_academic_events?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("overseas_visited_for_academic_events", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                e. Participation and contributions in the area of your academic and professional expertise :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.participation_and_contributions.length}
                                    onChange={(yes) => {
                                      handle("participation_and_contributions", "yes", {
                                        id: 0,
                                        details: "",
                                        city: "",
                                        country: "",
                                        institution_sponsored: "",
                                        nature_of_visit: "",
                                        from_date: "",
                                        to_date: "",
                                        ...(IsOldReportYear(report) && { duration: "" }),
                                        attachment: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.participation_and_contributions.length}
                                    onChange={(no) => {
                                      handle("participation_and_contributions", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.participation_and_contributions.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Details</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td className="">From</td>
                                              <td className="">To</td>
                                              {IsOldReportYear(report) &&
                                                <td>YY-MM</td>
                                              }
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">Attachment</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.participation_and_contributions?.map((parti, index) => {
                                        return (
                                          <tr key={parti.id}>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`participation_and_contributions_details_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={parti?.details} onChange={(e) => setData(e.target.value, "participation_and_contributions", "details", index)}>
                                                  <option value="">Select Details</option>
                                                  <option value="pg">PG</option>
                                                  <option value="phd_examiner">Ph.D.Examiner</option>
                                                  <option value="doctoral_committee_member">Doctoral Committee Member</option>
                                                  <option value="others">Others</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.participation_and_contributions[parti.id.toString()]?.details?.message ? `Details ${validation?.participation_and_contributions[parti.id.toString()]?.details?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`participation_and_contributions_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={parti?.from_date} onChange={(e) => setData(e.target.value, "participation_and_contributions", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.participation_and_contributions[parti.id.toString()]?.from_date?.message ? `From Date ${validation?.participation_and_contributions[parti.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`participation_and_contributions_to_date_${index}`] = el}
                                                    type="date"
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={parti?.to_date}
                                                    onChange={(e) => setData(e.target.value, "participation_and_contributions", "to_date", index)}
                                                    min={moment(parti?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.participation_and_contributions[parti.id.toString()]?.to_date?.message ? `To Date ${validation?.participation_and_contributions[parti.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                              {IsOldReportYear(report) &&
                                                <td>
                                                  <div>
                                                    <input
                                                      ref={el => inputRefE.current[`participation_and_contributions_duration_${index}`] = el}
                                                      type="text" className="fieldinputreport" placeholder="Enter YY-MM" maxLength={5} key={index} defaultValue={parti.duration} onChange={(e) => setData(e.target.value, "participation_and_contributions", "duration", index)} />
                                                  </div>
                                                  <small className="validationerror">{validation?.participation_and_contributions[parti.id.toString()]?.duration?.message ? `Duration ${validation?.participation_and_contributions[parti.id.toString()]?.duration?.message}` : ""}</small>
                                                </td>
                                              }
                                            </td>
                                            <td>
                                              <input key={index} type="file" className="fieldinputfilereport" id="myfile" onChange={(e) => UploadDocument(e, "participation_and_contributions", "attachment", index)} accept="application/pdf" />
                                              <br />
                                              <small className="d-flex">Max File upload:200kb</small>
                                              <br />
                                              {parti?.attachment ? (
                                                <span
                                                  className="namelink"
                                                  onClick={() => {


                                                    window.open(`${imagepath}${parti?.attachment}`, "_blank");
                                                  }}
                                                >
                                                  View Document
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {report?.participation_and_contributions?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("participation_and_contributions", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.participation_and_contributions?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("participation_and_contributions", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                f. Editor-in-chief / Editorial Board Member / Peer Reviewer / Others :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.editor_in_chief.length}
                                    onChange={(yes) => {
                                      handle("editor_in_chief", "yes", {
                                        id: 0,
                                        role: "",
                                        title_of_journal: "",
                                        journal_publisher: "",
                                        issn: "",
                                        year: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.editor_in_chief.length}
                                    onChange={(no) => {
                                      handle("editor_in_chief", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.editor_in_chief.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Role</th>
                                        <th scope="col">Title of Journal</th>
                                        <th scope="col">Journal Publisher</th>
                                        <th scope="col">ISSN</th>
                                        <th scope="col">Duration (Year)</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.editor_in_chief?.map((edit, index) => {
                                        return (
                                          <tr key={edit.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`editor_in_chief_role_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Role" defaultValue={edit?.role} onChange={(e) => setData(e.target.value, "editor_in_chief", "role", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.editor_in_chief[edit.id.toString()]?.role?.message ? `Role ${validation?.editor_in_chief[edit.id.toString()]?.role?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`editor_in_chief_title_of_journal_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Title of Journal" defaultValue={edit?.title_of_journal} onChange={(e) => setData(e.target.value, "editor_in_chief", "title_of_journal", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.editor_in_chief[edit.id.toString()]?.title_of_journal?.message ? `Title of Journal ${validation?.editor_in_chief[edit.id.toString()]?.title_of_journal?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`editor_in_chief_journal_publisher_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Journal Publisher" defaultValue={edit?.journal_publisher} onChange={(e) => setData(e.target.value, "editor_in_chief", "journal_publisher", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.editor_in_chief[edit.id.toString()]?.journal_publisher?.message ? `Journal Publisher ${validation?.editor_in_chief[edit.id.toString()]?.journal_publisher?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`editor_in_chief_issn_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter ISSN" defaultValue={edit?.issn} onChange={(e) => setData(e.target.value, "editor_in_chief", "issn", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.editor_in_chief[edit.id.toString()]?.issn?.message ? `ISSN ${validation?.editor_in_chief[edit.id.toString()]?.issn?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`editor_in_chief_year_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Year" defaultValue={edit?.year} maxLength={4} onChange={(e) => setData(e.target.value, "editor_in_chief", "year", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.editor_in_chief[edit.id.toString()]?.year?.message ? `Year ${validation?.editor_in_chief[edit.id.toString()]?.year?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              {report?.editor_in_chief?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("editor_in_chief", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.editor_in_chief?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("editor_in_chief", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                g. National / International academic assignment for more than 1 year (Full-time) :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.national_or_international_assignment.length}
                                    onChange={(yes) => {
                                      handle("national_or_international_assignment", "yes", {
                                        id: 0,
                                        type: "",
                                        level: "",
                                        nature_of_assignment: "",
                                        from_date: "",
                                        to_date: "",
                                        duration: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.national_or_international_assignment.length}
                                    onChange={(no) => {
                                      handle("national_or_international_assignment", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.national_or_international_assignment.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Post / Assignment</th>
                                        <th scope="col">
                                          National / International <br />
                                          Organization / University
                                        </th>
                                        <th scope="col">Nature of Assignment</th>
                                        <th scope="col">
                                          Duration
                                          <table className="table">
                                            <tr>
                                              <td style={{ width: '30%' }}>From</td>
                                              <td style={{ width: '30%' }}>To</td>
                                              <td style={{ width: '40%' }}>YY-MM</td>
                                            </tr>
                                          </table>
                                        </th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.national_or_international_assignment?.map((nationalassign, index) => {
                                        return (
                                          <tr key={nationalassign.id}>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`national_or_international_assignment_type_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={nationalassign?.type} onChange={(e) => setData(e.target.value, "national_or_international_assignment", "type", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="post">Post</option>
                                                  <option value="assignment">Assignment</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.national_or_international_assignment[nationalassign.id.toString()]?.type?.message ? `Type ${validation?.national_or_international_assignment[nationalassign.id.toString()]?.type?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`national_or_international_assignment_level_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={nationalassign?.level} onChange={(e) => setData(e.target.value, "national_or_international_assignment", "level", index)}>
                                                  <option value="">Select Level</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                  <option value="organization">Organization</option>
                                                  <option value="university">University</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.national_or_international_assignment[nationalassign.id.toString()]?.level?.message ? `Level ${validation?.national_or_international_assignment[nationalassign.id.toString()]?.level?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`national_or_international_assignment_nature_of_assignment_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Nature of Assignment" defaultValue={nationalassign?.nature_of_assignment} onChange={(e) => setData(e.target.value, "national_or_international_assignment", "nature_of_assignment", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.national_or_international_assignment[nationalassign.id.toString()]?.nature_of_assignment?.message ? `Assignment ${validation?.national_or_international_assignment[nationalassign.id.toString()]?.nature_of_assignment?.message}` : ""}</small>
                                            </td>
                                            <td className="d-flex" style={{ marginTop: '0.5px' }}>
                                              <div className="me-2 mb27">
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`national_or_international_assignment_from_date_${index}`] = el}
                                                    type="date" className="fieldinputreport" placeholder="Enter" key={index} defaultValue={nationalassign?.from_date} onChange={(e) => setData(e.target.value, "national_or_international_assignment", "from_date", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.national_or_international_assignment[nationalassign.id.toString()]?.from_date?.message ? `From Date ${validation?.national_or_international_assignment[nationalassign.id.toString()]?.from_date?.message}` : ""}</small>
                                              </div>
                                              <div className="me-2">
                                                <div>
                                                  <input
                                                    type="date"
                                                    ref={el => inputRefE.current[`national_or_international_assignment_to_date_${index}`] = el}
                                                    className="fieldinputreport"
                                                    placeholder="Enter"
                                                    key={index}
                                                    defaultValue={nationalassign?.to_date}
                                                    onChange={(e) => setData(e.target.value, "national_or_international_assignment", "to_date", index)}
                                                    min={moment(nationalassign?.from_date).format("yyyy-MM-DD")}
                                                  />
                                                </div>
                                                <small className="validationerror">{validation?.national_or_international_assignment[nationalassign.id.toString()]?.to_date?.message ? `To Date ${validation?.national_or_international_assignment[nationalassign.id.toString()]?.to_date?.message}` : ""}</small>
                                              </div>
                                              <div>
                                                <div>
                                                  <input
                                                    ref={el => inputRefE.current[`national_or_international_assignment_duration_${index}`] = el}
                                                    type="text" className="fieldinputreport" placeholder="Enter YY-MM" key={index} defaultValue={nationalassign.duration} maxLength={5} onChange={(e) => setData(e.target.value, "national_or_international_assignment", "duration", index)} />
                                                </div>
                                                <small className="validationerror">{validation?.national_or_international_assignment[nationalassign.id.toString()]?.duration?.message ? `Duration ${validation?.national_or_international_assignment[nationalassign.id.toString()]?.duration?.message}` : ""}</small>
                                              </div>
                                            </td>
                                            <td>
                                              {report?.national_or_international_assignment?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("national_or_international_assignment", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.national_or_international_assignment?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("national_or_international_assignment", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                            <div>
                              <h6 className="reporttitle">
                                h. Fellow / Life Member / Member of Professional Bodies / Societies :
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={report?.fellow_or_life_member.length}
                                    onChange={(yes) => {
                                      handle("fellow_or_life_member", "yes", {
                                        id: 0,
                                        name: "",
                                        type: "",
                                        level: "",
                                        registration_no: "",
                                        registration_year: "",
                                      });
                                    }}
                                  />
                                  &nbsp;Yes
                                </label>
                                <label>
                                  <input
                                    className="ratiobuttonalign"
                                    type="radio"
                                    checked={!report?.fellow_or_life_member.length}
                                    onChange={(no) => {
                                      handle("fellow_or_life_member", "no");
                                    }}
                                  />
                                  &nbsp;No
                                </label>
                              </h6>
                              {report?.fellow_or_life_member.length > 0 && (
                                <div className="scroll-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Name of the Professional Bodies / Societies</th>
                                        <th scope="col">Fellow / Life Member / Member</th>
                                        <th scope="col">National / International</th>
                                        <th scope="col">Registration No</th>
                                        <th scope="col">Registration Year</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {report?.fellow_or_life_member?.map((fellow, index) => {
                                        return (
                                          <tr key={fellow.id}>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`fellow_or_life_member_name_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Name" defaultValue={fellow?.name} onChange={(e) => setData(e.target.value, "fellow_or_life_member", "name", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.fellow_or_life_member[fellow.id.toString()]?.name?.message ? `Name ${validation?.fellow_or_life_member[fellow.id.toString()]?.name?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`fellow_or_life_member_type_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={fellow?.type} onChange={(e) => setData(e.target.value, "fellow_or_life_member", "type", index)}>
                                                  <option value="">Select Type</option>
                                                  <option value="fellow">Fellow</option>
                                                  <option value="life_member">Life Member</option>
                                                  <option value="member">Member</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.fellow_or_life_member[fellow.id.toString()]?.type?.message ? `Type ${validation?.fellow_or_life_member[fellow.id.toString()]?.type?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <select
                                                  ref={el => inputRefE.current[`fellow_or_life_member_level_${index}`] = el}
                                                  key={index} className="fieldinputselectreport" defaultValue={fellow?.level} onChange={(e) => setData(e.target.value, "fellow_or_life_member", "level", index)}>
                                                  <option value="">Select Level</option>
                                                  <option value="national">National</option>
                                                  <option value="international">International</option>
                                                </select>
                                              </div>
                                              <small className="validationerror">{validation?.fellow_or_life_member[fellow.id.toString()]?.level?.message ? `Level ${validation?.fellow_or_life_member[fellow.id.toString()]?.level?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`fellow_or_life_member_registration_no_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Registration No" defaultValue={fellow?.registration_no} onChange={(e) => setData(e.target.value, "fellow_or_life_member", "registration_no", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.fellow_or_life_member[fellow.id.toString()]?.registration_no?.message ? `Registration No ${validation?.fellow_or_life_member[fellow.id.toString()]?.registration_no?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              <div>
                                                <input
                                                  ref={el => inputRefE.current[`fellow_or_life_member_registration_year_${index}`] = el}
                                                  key={index} type="text" className="fieldinputreport" placeholder="Enter Registration Year" defaultValue={fellow?.registration_year} maxLength={4} onChange={(e) => setData(e.target.value, "fellow_or_life_member", "registration_year", index)} />
                                              </div>
                                              <small className="validationerror">{validation?.fellow_or_life_member[fellow.id.toString()]?.registration_year?.message ? `Registration Year ${validation?.fellow_or_life_member[fellow.id.toString()]?.registration_year?.message}` : ""}</small>
                                            </td>
                                            <td>
                                              {report?.fellow_or_life_member?.length - 1 === index && (
                                                <span
                                                  className="material-symbols-outlined addoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setAddArrayData("fellow_or_life_member", index);
                                                  }}
                                                >
                                                  add
                                                </span>
                                              )}
                                              {report?.fellow_or_life_member?.length !== 1 && (
                                                <span
                                                  className="material-symbols-outlined removeoption"
                                                  type="button"
                                                  onClick={() => {
                                                    setRemoveArrayData("fellow_or_life_member", index);
                                                  }}
                                                >
                                                  remove
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      <div className="row my-5">
                        <div className="col-lg-6 mx-auto my-auto centertext">
                          <div className="row">
                            {report?.editable === true ? '' :
                              <div className="col-lg-5">
                                <button type="submit" className="rejectbutton draft-btn" onClick={(e) => handleSubmit(e, 'saveusdraft')}>
                                  {isSpecific ? 'Update In Draft' : 'Save As Draft'}
                                </button>
                              </div>
                            }
                            <div className="col-lg-5">
                              <div
                                className="approvebutton"
                                onClick={() => {
                                  setStatusAcceptModel(true);
                                }}
                              >
                                Submit
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  <CustomModal
                    open={statusAcceptModel}
                    onClickOutside={() => {
                      setStatusAcceptModel(false);
                    }}
                  >
                    <div className="modal-content Modal-View m-auto">
                      <div className="modalHeader text-center py-2">
                        <h5 className="font-bold mt-2">Confirmation !</h5>
                      </div>
                      <div className="modal-body p-0">
                        <div className="container">
                          <div></div>
                          <div>
                            <h6 className="confirmmodeltext my-4">Are You Sure?</h6>
                          </div>
                          <div>
                            <h6 className="confirmmodeltext my-4">Once Submitted cannot be revote this !</h6>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer border-0">
                        <div className="my-3">
                          <button
                            type="button"
                            className="btn mx-2 modelclosebtn"
                            onClick={() => {
                              setStatusAcceptModel(false);
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button className="btn mx-2 approvebutton" onClick={(e) => handleSubmit(e, "submit")}>
                            yes, Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </CustomModal>
                </form>
              </div >
            </div >
          </div >
        </section >
      </div >
    </>
  );
};

export default StaffActivityReport;
